/* AG Spin Wheel, externalized from AG-Spin-Wheel.liquid (was ~80KB inline sitewide via the footer group). Self-bootstraps off the .ag-sw root; loaded deferred + cached. */
(function () {
    // A wedge label may end in "*" pointing at the note under the wheel
    // (e.g. FREE NEXT DAY*). Drop it wherever the prize is named in words.
    function displayLabel(label) {
      return (label || '').toString().replace(/\s*\*+\s*$/, '').trim();
    }
    var root = document.querySelector('.ag-sw[id^="ag-sw-"]');
    if (!root) return;
    // Idempotency guard: if the section is placed twice (it's a sitewide popup)
    // or the script tag is duplicated, both copies select THIS same first root.
    // Without this, slices get drawn twice and every handler binds twice
    // (double submit/fetch). Bail if we've already initialised this root.
    if (root.dataset.agSwBound === '1') return;
    root.dataset.agSwBound = '1';
    var ID_BASE = root.id.replace(/^ag-sw-/, '');

    var SECTION_ID = root.dataset.sectionId;
    var ENDPOINT = root.dataset.endpoint;
    var TOKEN = root.dataset.token;
    var TRIGGER = root.dataset.trigger || 'timed';
    var TRIGGER_DELAY = parseInt(root.dataset.triggerDelay, 10) || 6;
    var COOLDOWN_DAYS = parseInt(root.dataset.cooldownDays, 10) || 30;
    var AUDIENCE_PCT = parseInt(root.dataset.audiencePct, 10);
    if (isNaN(AUDIENCE_PCT)) AUDIENCE_PCT = 100;
    var FIRST_TIME_ONLY = root.dataset.firstTimeOnly === '1';
    var PAID_HOLD = root.dataset.paidHold === '1';
    var PAID_HOLD_PAGES = parseInt(root.dataset.paidHoldPages, 10) || 2;
    var PAID_HOLD_SECONDS = parseInt(root.dataset.paidHoldSeconds, 10);
    if (isNaN(PAID_HOLD_SECONDS)) PAID_HOLD_SECONDS = 30;
    var SHOW_STICKY = root.dataset.showSticky === '1';
    var STICKY_POSITION = root.dataset.stickyPosition || 'left';
    var STICKY_TEXT_PRE = root.dataset.stickyText || 'Got a code waiting';
    var STICKY_TEXT_POST = root.dataset.stickyTextAfter || 'View your code';
    var STICKY_TEXT_NOPRIZE = root.dataset.stickyTextNoprize || 'View your spin';
    var ENABLE_AUDIO = root.dataset.enableAudio === '1';
    var CODE_EXPIRY_DAYS = parseInt(root.dataset.codeExpiryDays, 10) || 7;
    var USE_KLAVIYO_EXPIRY = root.dataset.useKlaviyoExpiry !== '0';
    // Stable key: the section's own handle (ag_spin_wheel_xxx), not the full section id, which
    // carries a theme-specific prefix and so changed whenever the theme was republished, showing
    // the wheel again to everyone who had already spun or closed it.
    var STATE_KEY = 'ag_sw_state_' + String(SECTION_ID || '').split('__').pop();
    (function migrateState() {
      try {
        if (localStorage.getItem(STATE_KEY)) return;
        var suffix = '__' + String(SECTION_ID || '').split('__').pop();
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (k && k !== STATE_KEY && k.indexOf('ag_sw_state_') === 0 && k.slice(-suffix.length) === suffix) {
            localStorage.setItem(STATE_KEY, localStorage.getItem(k));
            return;
          }
        }
      } catch (e) {}
    })();

    // ── Test mode ─────────────────────────────────────────────────────
    // ?ag_sw_test=<secret>&ag_sw_prize=<index> on any URL: bypass the
    // once-per-email + cooldown gates, force a prize, and fire the REAL
    // Spun Wheel event so each branch's Klaviyo flow/email can be tested
    // on demand. The secret is validated server-side (separate from the
    // public TOKEN), so guessing the param name alone can't farm prizes.
    var TEST_MODE = false, TEST_SECRET = '', FORCE_PRIZE_INDEX = -1;
    var TEST_EMAIL_KEY = 'ag_sw_test_email';
    try {
      var _qs = new URLSearchParams(window.location.search);
      var _t = _qs.get('ag_sw_test');
      if (_t) {
        TEST_MODE = true;
        TEST_SECRET = _t;
        var _fp = _qs.get('ag_sw_prize');
        if (_fp !== null && _fp !== '' && !isNaN(parseInt(_fp, 10))) FORCE_PRIZE_INDEX = parseInt(_fp, 10);
        try { localStorage.removeItem(STATE_KEY); } catch (e) {} // never route to the won view in test mode
      }
    } catch (e) {}

    // Parse prize config
    var prizes = [];
    try {
      var jsonNode = root.querySelector('[data-ag-sw-prizes]');
      prizes = JSON.parse(jsonNode.textContent.trim()) || [];
    } catch (e) { prizes = []; }
    if (prizes.length < 2) {
      // Wheel needs at least 2 slices to be useful, bail silently if not configured
      return;
    }

    // ── Cooldown / state ──────────────────────────────────────────────
    function loadState() {
      try { return JSON.parse(localStorage.getItem(STATE_KEY) || 'null'); }
      catch (e) { return null; }
    }
    function saveState(state) {
      if (TEST_MODE) return; // never persist in test mode, keeps re-spins unlocked
      try { localStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch (e) {}
    }
    // State version. A spin result is saved with state_v: STATE_VERSION only
    // when the backend sent the prize's identity (prize_label and
    // klaviyo_coupon_id, 2026-09-30 and later). Anything saved before that
    // copied its coupon and label from prizes[stale index], or was saved by the
    // older build against the NO PRIZE stand-in slot, so it cannot be trusted
    // to say which prize this visitor won. The sticky tab sends such a state
    // back to the entry form instead of replaying it: re-entering the email
    // makes the backend resolve the prize again from the Spins sheet.
    var STATE_VERSION = 2;
    function stateTrusted(s) {
      return !!s && s.state_v === STATE_VERSION;
    }

    // Stable per-device ID, server-side device-conflict check uses this
    // to detect the same device trying to spin with multiple emails.
    // localStorage persistence makes it survive across sessions; clearing
    // it (incognito, fresh device) is the only way to "reset".
    function getOrCreateDeviceId() {
      var key = 'ag_sw_device_id';
      var id = '';
      try { id = localStorage.getItem(key) || ''; } catch (e) {}
      if (!id) {
        id = 'dev_' + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
        try { localStorage.setItem(key, id); } catch (e) {}
      }
      return id;
    }
    function isCoolingDown() {
      if (TEST_MODE) return false;
      var s = loadState();
      if (!s) return false;
      // Most recent of either interaction counts.
      var last = Math.max(s.lastSpunAt || 0, s.lastDismissedAt || 0);
      if (!last) return false;
      if (COOLDOWN_DAYS <= 0) return true; // 0 = never re-show
      var ageMs = Date.now() - last;
      return ageMs < COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
    }
    // Once a visitor has actually spun (won or no-prize), the popup
    // should never auto-re-trigger. The backend enforces one-spin-per
    // -email so re-popping it would just dead-end on already_spun for
    // a no-prize spinner, or nag a winner who's already converted.
    // The sticky tab still shows so they can revisit on demand.
    // A stored win whose prize is no longer on the wheel is saved with
    // prize_index -1 (there is no wedge to point at), so a held code or the
    // already_spun flag counts as having spun too.
    function hasSpun() {
      if (TEST_MODE) return false;
      var s = loadState();
      if (!s) return false;
      if (typeof s.prize_index === 'number' && s.prize_index >= 0) return true;
      return !!(s.code || s.already_spun);
    }

    // ── Build wheel SVG slices ────────────────────────────────────────
    var sliceAngle = 360 / prizes.length;
    var rotGroup = root.querySelector('[data-ag-sw-wheel-rot]');
    var ns = 'http://www.w3.org/2000/svg';

    function deg2rad(d) { return d * Math.PI / 180; }
    function pointOnCircle(cx, cy, r, angleDeg) {
      var a = deg2rad(angleDeg - 90); // -90 so 0deg = top
      return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) };
    }
    function buildSlice(i) {
      var p = prizes[i];
      var startA = i * sliceAngle;
      var endA = startA + sliceAngle;
      var pStart = pointOnCircle(100, 100, 100, startA);
      var pEnd = pointOnCircle(100, 100, 100, endA);
      var largeArc = sliceAngle > 180 ? 1 : 0;
      var d = 'M 100 100 ' +
              'L ' + pStart.x + ' ' + pStart.y + ' ' +
              'A 100 100 0 ' + largeArc + ' 1 ' + pEnd.x + ' ' + pEnd.y + ' Z';

      var path = document.createElementNS(ns, 'path');
      path.setAttribute('d', d);
      path.setAttribute('fill', p.color || '#c8102e');
      // Hairline separators. A translucent white line vanished wherever two
      // light slices met, so the wheel read as one shape (Michael, 28 Sep,
      // EU #180). Mid grey shows on white, grey and black slices alike.
      path.setAttribute('stroke', '#9a9a9a');
      path.setAttribute('stroke-width', '0.6');
      path.setAttribute('stroke-linejoin', 'round');
      rotGroup.appendChild(path);

      // Label, sits along the radius of its slice, reading outward.
      // For bottom-half slices we flip 180° so text isn't upside-down.
      // Font-size adapts to label length so long words don't overflow
      // the rim; position is anchored at radius 58 (just past the hub).
      var midA = startA + sliceAngle / 2;

      // If this slice carries a product/asset image, render it in place of the
      // text label, letterboxed near the rim (radius 74), rotated so its top
      // points outward. Set the slice colour to the image background (or use a
      // transparent PNG) so the edges blend into the wedge.
      if (p.image) {
        var imgPos = pointOnCircle(100, 100, 74, midA);
        var imgRot = midA;
        var imgBox = Math.max(28, Math.min(48, 384 / prizes.length));
        var img = document.createElementNS(ns, 'image');
        img.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', p.image);
        img.setAttribute('href', p.image);
        img.setAttribute('x', imgPos.x - imgBox / 2);
        img.setAttribute('y', imgPos.y - imgBox / 2);
        img.setAttribute('width', imgBox);
        img.setAttribute('height', imgBox);
        img.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        img.setAttribute('transform', 'rotate(' + imgRot + ' ' + imgPos.x + ' ' + imgPos.y + ')');
        rotGroup.appendChild(img);
        return;
      }

      // Wrap a long label onto multiple lines so it stays legible in the
      // narrow wedge instead of shrinking to a thread. Labels <= 11 chars stay
      // on one line; longer ones greedily wrap on word boundaries (~10/line).
      // The stored label text is unchanged, so the win screen etc. read cleanly.
      var labelRaw = (p.label || '').toUpperCase();
      var lines;
      if (labelRaw.length <= 11) {
        lines = [labelRaw];
      } else {
        var words = labelRaw.split(/\s+/).filter(function (w) { return w.length; });
        // Prefer TWO balanced lines: a third line runs across the narrow wedge
        // and scatters ("FREE NEXT / DAY / DELIVERY"). Pick the word split with
        // the shortest longer line (ties keep the longer first line), and use
        // it while that line stays within 13 characters; otherwise fall back
        // to the greedy ~10 per line wrap.
        var best = null;
        for (var sp = 1; sp < words.length; sp++) {
          var a = words.slice(0, sp).join(' '), b = words.slice(sp).join(' ');
          var worst = Math.max(a.length, b.length);
          if (!best || worst <= best.worst) best = { lines: [a, b], worst: worst };
        }
        if (best && best.worst <= 13) {
          lines = best.lines;
        } else {
          lines = []; var cur = '';
          for (var wi = 0; wi < words.length; wi++) {
            if (!cur) cur = words[wi];
            else if ((cur + ' ' + words[wi]).length <= 10) cur += ' ' + words[wi];
            else { lines.push(cur); cur = words[wi]; }
          }
          if (cur) lines.push(cur);
        }
        if (!lines.length) lines = [labelRaw];
      }
      var maxLineLen = 1;
      for (var ll = 0; ll < lines.length; ll++) maxLineLen = Math.max(maxLineLen, lines[ll].length);
      var availableUserUnits = 80;
      var charWidthFactor = 0.55;
      var maxByLen = availableUserUnits / (maxLineLen * charWidthFactor);
      var fontSize = Math.max(6.5, Math.min(prizes.length > 6 ? 9.5 : 11, maxByLen));
      fontSize = Math.round(fontSize * 10) / 10;

      var labelPos = pointOnCircle(100, 100, 64, midA);
      var rotation = midA - 90;
      var flipped = midA > 90 && midA < 270;
      if (flipped) rotation += 180;
      // A 180 degree flip already turns the text upright for the reader, so
      // line 1 stays on top. Reversing the lines here (as this used to) made a
      // left-half label read "DELIVERY DAY FREE NEXT".
      var renderLines = lines;
      var label = document.createElementNS(ns, 'text');
      label.setAttribute('x', labelPos.x);
      label.setAttribute('y', labelPos.y);
      label.setAttribute('fill', p.text_color || '#fff');
      label.setAttribute('font-family', 'Barlow Condensed, Barlow, sans-serif');
      label.setAttribute('font-weight', '600');
      label.setAttribute('font-size', String(fontSize));
      label.setAttribute('letter-spacing', '0.16em');
      label.setAttribute('text-anchor', 'middle');
      label.setAttribute('dominant-baseline', 'middle');
      label.setAttribute('transform', 'rotate(' + rotation + ' ' + labelPos.x + ' ' + labelPos.y + ')');
      if (renderLines.length === 1) {
        label.textContent = renderLines[0];
      } else {
        var lineHeight = fontSize * 1.12;
        for (var lk = 0; lk < renderLines.length; lk++) {
          var ts = document.createElementNS(ns, 'tspan');
          ts.setAttribute('x', labelPos.x);
          ts.setAttribute('dy', lk === 0 ? (-((renderLines.length - 1) / 2) * lineHeight) : lineHeight);
          ts.textContent = renderLines[lk];
          label.appendChild(ts);
        }
      }
      rotGroup.appendChild(label);
    }
    for (var i = 0; i < prizes.length; i++) buildSlice(i);
    // No decorative studs, premium look favours empty space over ornament.

    // ── Confetti ──────────────────────────────────────────────────────
    // Tiny canvas-based implementation. Bright AG-themed colours; runs
    // for ~3 seconds then auto-removes itself. Skipped for users who
    // prefer reduced motion.
    function fireConfetti(extraColor, durationMs) {
      try {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      } catch (e) {}
      durationMs = durationMs || 3500;
      var canvas = document.createElement('canvas');
      canvas.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:100000';
      document.body.appendChild(canvas);
      function size() {
        canvas.width = window.innerWidth * (window.devicePixelRatio || 1);
        canvas.height = window.innerHeight * (window.devicePixelRatio || 1);
        canvas.style.width = window.innerWidth + 'px';
        canvas.style.height = window.innerHeight + 'px';
      }
      size();
      var dpr = window.devicePixelRatio || 1;
      var ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);
      var W = window.innerWidth;
      var H = window.innerHeight;
      // Standard palette + the slice's accent (if provided) gets
      // weighted in for a tier-specific celebration vibe.
      var colors = ['#c8102e', '#ffffff', '#dca668', '#111111', '#ffd23f'];
      if (extraColor) {
        colors = [extraColor, extraColor, extraColor].concat(colors);
      }
      var particles = [];
      // Burst from the wheel column area on desktop, screen centre on mobile
      var card = root.querySelector('.ag-sw__card');
      var rect = card ? card.getBoundingClientRect() : { left: W/2, top: H/2, width: 0, height: 0 };
      var originX = rect.left + rect.width / 2;
      var originY = rect.top + rect.height / 3;
      for (var i = 0; i < 180; i++) {
        var angle = (Math.random() - 0.5) * Math.PI * 1.4 - Math.PI / 2;
        var speed = 8 + Math.random() * 14;
        particles.push({
          x: originX,
          y: originY,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          g: 0.32 + Math.random() * 0.18,
          color: colors[Math.floor(Math.random() * colors.length)],
          size: 4 + Math.random() * 7,
          rot: Math.random() * 360,
          vRot: (Math.random() - 0.5) * 22,
          shape: Math.random() > 0.5 ? 'rect' : 'circle',
          life: 1
        });
      }
      var startTime = performance.now();
      function tick(now) {
        var elapsed = now - startTime;
        ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < particles.length; i++) {
          var p = particles[i];
          p.x += p.vx;
          p.y += p.vy;
          p.vy += p.g;
          p.vx *= 0.995;
          p.rot += p.vRot;
          p.life = Math.max(0, 1 - elapsed / durationMs);
          ctx.save();
          ctx.globalAlpha = p.life;
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot * Math.PI / 180);
          ctx.fillStyle = p.color;
          if (p.shape === 'rect') {
            ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 1.5);
          } else {
            ctx.beginPath();
            ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.restore();
        }
        if (elapsed < durationMs) {
          requestAnimationFrame(tick);
        } else {
          canvas.remove();
        }
      }
      window.addEventListener('resize', size, { once: true, passive: true });
      requestAnimationFrame(tick);
    }

    // ── Klaviyo onsite tracking (anonymous; merged when identified) ──
    function trackKlaviyo(eventName, props) {
      try {
        var payload = ['track', eventName, props || {}];
        if (window.klaviyo && typeof window.klaviyo.push === 'function') {
          window.klaviyo.push(payload);
        } else if (window._learnq && typeof window._learnq.push === 'function') {
          window._learnq.push(payload);
        }
      } catch (e) { /* never break the page over analytics */ }
    }

    var didSpin = false;

    // ── Open / close popup ────────────────────────────────────────────
    function openPopup() {
      if (window.AGPopups) window.AGPopups.claim('spinwheel');
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      // Force reflow before adding is-open so transition runs
      root.offsetHeight;
      root.classList.add('is-open');
      root._agTrigger = document.activeElement;
      if (typeof trapFocus === 'function') { try { trapFocus(root, root.querySelector('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])') || root); } catch (e) {} }
      document.body.style.overflow = 'hidden';
      showView('enter');
      resetWheelRotation();
      didSpin = false;
      // Reset the submit button state so a stale 'Spinning…' label
      // from a previous interaction doesn't persist.
      var sBtn = root.querySelector('[data-ag-sw-submit]');
      var sLbl = root.querySelector('[data-ag-sw-cta-label]');
      if (sBtn) sBtn.disabled = false;
      if (sLbl) {
        var defaultLabel = sLbl.dataset.defaultLabel;
        if (!defaultLabel) {
          sLbl.dataset.defaultLabel = sLbl.textContent;
          defaultLabel = sLbl.textContent;
        }
        sLbl.textContent = defaultLabel;
      }
      // Focus the email input once the popup-open transition is settled
      // so users can start typing straight away. Only focus if entry
      // view is the active one (skip when openPopupSmart immediately
      // switches to the won view).
      setTimeout(function () {
        var entryVis = root.querySelector('[data-ag-sw-view="enter"]');
        if (entryVis && entryVis.hidden) return;
        var input = root.querySelector('input[name="email"]');
        if (input && !input.disabled) {
          try { input.focus({ preventScroll: true }); }
          catch (e) { input.focus(); }
        }
      }, 400);
      trackKlaviyo('Viewed Spin Wheel', {
        section_id: SECTION_ID,
        slice_count: prizes.length
      });
    }
    function closePopup() {
      // Fire abandonment event only if they hadn't actually spun.
      if (!didSpin) {
        trackKlaviyo('Closed Spin Wheel Without Spinning', {
          section_id: SECTION_ID
        });
      }
      // Stamp the cooldown so we don't keep re-showing on every page
      // load. Counts both spins AND dismissals as 'interacted'.
      // CRITICALLY: preserve any prize/code/expires_at/already_spun
      // fields stamped by a previous successful spin, losing them
      // would revert the sticky tab to the pre-spin state on next
      // page load.
      // Every saved field is carried over as it is (coupon, label, no_prize
      // and the state_v marker too): dropping coupon and label here left a
      // closed popup's state with nothing to identify the prize by. A state
      // without the marker stays without it, so closing the popup never makes
      // an old, untrusted state look current.
      var existing = loadState() || {};
      var next = {};
      for (var k in existing) {
        if (Object.prototype.hasOwnProperty.call(existing, k)) next[k] = existing[k];
      }
      next.lastSpunAt = existing.lastSpunAt || null;
      next.lastDismissedAt = Date.now();
      next.email = existing.email || null;
      next.prize_index = existing.prize_index;
      next.code = existing.code || '';
      next.expires_at = existing.expires_at || '';
      next.already_spun = !!existing.already_spun;
      saveState(next);
      root.classList.remove('is-open');
      if (window.AGPopups) window.AGPopups.release('spinwheel');
      if (typeof removeTrapFocus === 'function') { try { removeTrapFocus(root._agTrigger || null); } catch (e) {} }
      document.body.style.overflow = '';
      setTimeout(function () {
        root.hidden = true;
        root.setAttribute('aria-hidden', 'true');
        // After closing, surface the sticky reminder so they can
        // come back if they want.
        maybeShowSticky();
      }, 320);
    }

    // ── Sticky reminder side-tab ──────────────────────────────────────
    // Two tabs are emitted OUTSIDE the popup container (so they remain
    // visible when the popup is hidden via opacity). The section
    // setting controls which side(s) are activated; 'both' activates
    // both. Click reopens the popup, wired explicitly here since
    // these elements are outside root.
    //
    // Text + click behaviour adapt to whether the visitor has spun:
    //   - Pre-spin: pre-text, click goes to entry form (re-spin path).
    //   - Post-spin (state.code present): post-text, click jumps
    //     directly to the won view with the stored code, no
    //     backend round-trip needed.
    var stickyLeft = document.getElementById('ag-sw-' + ID_BASE + '-sticky-left');
    var stickyRight = document.getElementById('ag-sw-' + ID_BASE + '-sticky-right');

    // Three sticky states, each with its own text and click target:
    //   - unspun  (no prize_index in state): pre-text → entry form
    //   - won     (state.code present):     post-text → won view with
    //                                       stored code, no round-trip
    //   - noprize (prize_index set, no code): noprize-text → consolation
    //                                         view (NEVER the entry form
    //                                         - backend enforces one
    //                                         spin per email)
    // A stored code is only good until its expiry. Past that the spin backend's
    // daily purge has DELETED it from Shopify, so replaying it out of
    // localStorage shows the customer a dead code, with a Copy button and no
    // warning, on a screen that never contacts the backend. Worse, if they then
    // re-enter their email the backend re-mints against their original prize and
    // emails a DIFFERENT code, which is exactly the "screen says one code, email
    // says another" report (confirmed on the live site 2026-09-08 by planting a
    // code that had expired six days earlier and watching the popup serve it).
    //
    // Deliberately fails OPEN: a missing or unparseable expiry is treated as
    // live, because locking a winner out of a code that is actually fine is a
    // worse failure than showing one that has just lapsed.
    function storedCodeLive(s) {
      if (!s || !s.code) return false;
      if (!s.expires_at) return true;
      var t = Date.parse(s.expires_at);
      if (isNaN(t)) return true;
      return t > Date.now();
    }

    function spunState() {
      var s = loadState();
      if (!s) return 'unspun';
      var hasIdx = (typeof s.prize_index === 'number') && s.prize_index >= 0;
      if (storedCodeLive(s)) return 'won';
      // Had a code, and it has since lapsed. NOT 'won': routing must send them
      // to the entry form, where re-entering their email makes the backend
      // re-mint against the prize already on their Spins row. They keep the
      // prize they won and get a code that exists.
      if (s.code) return 'expired';
      if (hasIdx) return 'noprize';
      // Returning NO PRIZE spinner on a wheel with no NO PRIZE wedge to point at.
      if (s.already_spun && s.no_prize) return 'noprize';
      return 'unspun';
    }
    function applyStickyText() {
      var st = spunState();
      var txt = STICKY_TEXT_PRE;
      if (st === 'won') txt = STICKY_TEXT_POST;
      else if (st === 'noprize') txt = STICKY_TEXT_NOPRIZE;
      [stickyLeft, stickyRight].forEach(function (el) {
        if (!el) return;
        var lbl = el.querySelector('.ag-sw__sticky-label');
        if (lbl) lbl.textContent = txt;
        el.classList.remove('ag-sw__sticky--suppressed');
      });
    }
    applyStickyText();

    // Re-resolve a stored (positional) prize_index against the CURRENT wheel.
    // The wheel may have been rearranged since the visitor spun, so the raw
    // stored index can now point at a different slice. Match ONLY by the stable
    // identity we persisted (coupon, then label).
    //
    // There is deliberately NO positional fall back for a WIN. prize_index is
    // positional: when a slice is added, removed or reordered it silently points
    // at somebody else's prize, and the won view then renders that prize's name
    // next to the winner's REAL code. That is what the 2026-07-15 rebuild did,
    // it moved FREE PLAN off index 0 and dropped Plan_25off / Plan_50off from the
    // wheel entirely, so ~288 past winners could be shown a prize they never won.
    // A prize we cannot identify is handed to showStoredWin(), which shows what
    // they actually won, rather than guessed at from a stale offset.
    function resolveStoredIndex(s, st) {
      if (!s) return -1;
      var i;
      if (st === 'won') {
        // A saved coupon is the identity: it never falls back to a label, since a
        // wedge with the same words and another coupon is a different prize (the
        // backend's rule too). A ROTATING coupon (the clearance wedge) also
        // needs the saved label: an earlier run is another product, and its
        // winner gets -1, a stored win shown from their own label and code.
        // A coupon-less win matches by normalised label, and only a wedge
        // that carries a coupon can be a win.
        var coupon = String(s.coupon || '').trim();
        if (coupon) {
          for (i = 0; i < prizes.length; i++) {
            if (wedgeCarriesPrize(prizes[i], coupon, s.label)) return i;
          }
          return -1;
        }
        var key = prizeLabelKey(s.label);
        if (key) {
          for (i = 0; i < prizes.length; i++) {
            if (prizes[i] && prizes[i].klaviyo_coupon_id && prizeLabelKey(prizes[i].label) === key) return i;
          }
        }
        return -1; // no longer on the wheel, never guess positionally
      } else if (st === 'noprize') {
        // Any no-prize wedge will do (they're interchangeable), land on the
        // first slice with no coupon so it can't accidentally show a winning one.
        for (i = 0; i < prizes.length; i++) {
          if (prizes[i] && !prizes[i].klaviyo_coupon_id) return i;
        }
        // No NO PRIZE wedge on this wheel. Never fall back to the stored
        // position: it can point at a winning wedge.
        return -1;
      }
      var raw = parseInt(s.prize_index, 10);
      return (!isNaN(raw) && raw >= 0 && raw < prizes.length) ? raw : -1;
    }

    // The prize they won is no longer a slice on this wheel (it was removed or
    // renamed, or it was an earlier run of a rotating prize). Show what they
    // ACTUALLY won, from saved state: their own label and code, with the
    // generic copy (a stored prize carries no result_text, so no wedge's
    // product wording can reach this screen), and leave the
    // wheel where it is, there is no slice to land on, and snapping it to a
    // guessed offset is what showed winners the wrong prize in the first place.
    function showStoredWin(s) {
      if (!s || !s.code) return false;          // nothing trustworthy to show
      if (!storedCodeLive(s)) return false;     // expired: the code is gone from Shopify
      var label = (s.label || '').toString().trim();
      if (!label) return false;                 // legacy state: no label, no honest claim
      stopNotchTracking();
      rotGroup.classList.remove('is-looping');
      rotGroup.style.animationDelay = '';
      try {
        showResult(-1, s.code, s.expires_at, true, {
          label: label,
          klaviyo_coupon_id: s.coupon || 'stored'  // non-blank so it isn't read as a no-prize
        }, true); // only reached for a trusted (state_v) state: it is their own code
        showView('won');
      } catch (err) {
        if (window.console) console.error('[AG Spin Wheel] showStoredWin failed:', err);
        return false;
      }
      return true;
    }

    // ── Returning customers (2026-09-30) ──────────────────────────────
    // The spin backend replays a returning customer's saved result. It used to
    // send their STORED prize_index, which is positional: once the FREE
    // DUMBBELL STAND wedge was disabled every later wedge moved up one, and a
    // 'No Prize' spinner (stored index 3) was landed on 50% OFF and told to
    // check his inbox for a code that never existed. The backend now resolves
    // the prize by identity and sends it back (prize_label, klaviyo_coupon_id,
    // prize_on_wheel, no_prize); this build checks the wedge against that
    // before landing on anything, and asks for -1 (supports_stored_win) when
    // the prize is no longer on the wheel.
    function normLabel(s) {
      var t = String(s == null ? '' : s);
      try { t = t.normalize('NFKC'); } catch (e) {}
      return t.toLowerCase().replace(/[^a-z0-9%£€$]+/g, '');
    }
    // The backend's label rules (prizeLabelKey_ / sameWedgeLabel_ in the spin
    // script, 2026-09-30). A trailing run of "*" points at the note under the
    // wheel and is not part of the prize, so '50% OFF**' is '50% OFF' and
    // 'FREE NEXT DAY*' is 'FREE NEXT DAY'. Every label comparison goes
    // through prizeLabelKey.
    function stripFootnoteStars(label) {
      return String(label == null ? '' : label).replace(/\s*\*+\s*$/, '');
    }
    function prizeLabelKey(label) {
      return normLabel(stripFootnoteStars(label));
    }
    function sameWedgeLabel(a, b) {
      var k = prizeLabelKey(a);
      return !!k && k === prizeLabelKey(b);
    }
    // A ROTATING coupon is one coupon id for whichever product is on this run
    // (the clearance wedge: products and wording come from the Clearance tab
    // of the spin sheet, so a new run is a new wedge label and the SAME
    // coupon). Its coupon alone does not say which product they won: a wedge
    // carries their prize only under the same coupon AND the same label. A
    // winner of an earlier run ('50% OFF KETTLEBELL') must never be landed on
    // today's '50% OFF PLYO BOX' wedge, whose result_text names today's
    // product. The wedge blocks carry no rotating flag, so the list is here,
    // matching the backend's isRotatingCoupon_ (every 'clearance' kind prize).
    var ROTATING_COUPONS = ['Spin_Clearance'];
    function isRotatingCoupon(couponId) {
      return ROTATING_COUPONS.indexOf(String(couponId == null ? '' : couponId).trim()) >= 0;
    }
    // Does this wedge carry the prize named by (coupon, label)? A fixed coupon
    // is its own identity, whatever its label now says; a rotating one needs
    // the label too.
    function wedgeCarriesPrize(slot, coupon, label) {
      if (!slot) return false;
      var c = String(coupon == null ? '' : coupon).trim();
      if (!c || String(slot.klaviyo_coupon_id || '').trim() !== c) return false;
      return !isRotatingCoupon(c) || sameWedgeLabel(label, slot.label);
    }
    // A coupon-less label that names no prize: blank, a known no-prize
    // wording (the backend's list), or the label of a coupon-less wedge.
    var NO_PRIZE_LABEL_KEYS = ['noprize', 'nowin', 'nothing', 'betterlucknexttime', 'tryagain', 'tryagainnexttime', 'unlucky', 'noluck', 'sorry'];
    function labelNamesNoPrize(label) {
      var key = prizeLabelKey(label);
      if (!key || NO_PRIZE_LABEL_KEYS.indexOf(key) >= 0) return true;
      for (var i = 0; i < prizes.length; i++) {
        if (prizes[i] && !prizes[i].klaviyo_coupon_id && prizeLabelKey(prizes[i].label) === key) return true;
      }
      return false;
    }
    function firstNoPrizeIndex() {
      for (var i = 0; i < prizes.length; i++) {
        if (prizes[i] && !prizes[i].klaviyo_coupon_id) return i;
      }
      return -1;
    }
    // Does this wedge carry the prize the backend says they won?
    // A rotating coupon needs the same label as well (an earlier clearance
    // run is a different product), see wedgeCarriesPrize.
    function sliceMatchesResponse(slot, res) {
      if (!slot) return false;
      var resCoupon = String(res.klaviyo_coupon_id || '').trim();
      var slotCoupon = String(slot.klaviyo_coupon_id || '').trim();
      if (resCoupon) return wedgeCarriesPrize(slot, resCoupon, res.prize_label);
      if (!slotCoupon) return true; // both no-prize
      var key = prizeLabelKey(res.prize_label);
      return !!key && prizeLabelKey(slot.label) === key;
    }

    // NO PRIZE view copy. The markup holds the fresh-spin wording; a returning
    // customer who already spun and won nothing gets told exactly that.
    // mode: false = the fresh-spin wording, true = "already spun, no prize",
    // 'neutral' = "already spun" with no claim either way (used when an older
    // backend's answer cannot be trusted to say what they won).
    var noPrizeCopyDefaults = null;
    function setNoPrizeCopy(mode) {
      var view = root.querySelector('[data-ag-sw-view="noprize"]');
      if (!view) return;
      var eyebrow = view.querySelector('.ag-sw__eyebrow');
      var title = view.querySelector('.ag-sw__title');
      var sub = view.querySelector('.ag-sw__subtitle');
      if (!noPrizeCopyDefaults) {
        noPrizeCopyDefaults = {
          eyebrow: eyebrow ? eyebrow.textContent : '',
          title: title ? title.textContent : '',
          sub: sub ? sub.textContent : ''
        };
      }
      var c = mode === 'neutral'
        ? { eyebrow: 'Already spun', title: 'You have already spun', sub: 'Thanks for playing. We will keep you posted on the next drop.' }
        : mode
          ? { eyebrow: 'Already spun', title: 'You have already spun', sub: 'No prize this time. Thanks for playing, and we will keep you posted on the next drop.' }
          : noPrizeCopyDefaults;
      if (eyebrow) eyebrow.textContent = c.eyebrow;
      if (title) title.textContent = c.title;
      if (sub) sub.textContent = c.sub;
    }

    // Stop the waiting loop without landing anywhere. Used when the result is
    // shown from the response instead of from a wedge.
    function haltSpin(snapIndex) {
      cancelSpin();
      stopNotchTracking();
      rotGroup.classList.remove('is-looping');
      rotGroup.style.animationDelay = '';
      rotGroup.style.transition = 'none';
      if (typeof snapIndex === 'number' && snapIndex >= 0 && snapIndex < prizes.length) {
        var centre = snapIndex * sliceAngle + sliceAngle / 2;
        spinAngle = (360 - centre) % 360;
        applyWheelAngle(spinAngle);
      } else {
        resetWheelRotation();
      }
      try { rotGroup.getBoundingClientRect(); } catch (e) {}
    }

    // A returning prize with no wedge that carries it: render it from the
    // RESPONSE (label, code, expiry), through the same showResult(storedPrize)
    // path showStoredWin uses. The wheel does not move.
    function showResponseWin(res, alreadySpun) {
      var label = String(res.prize_label || '').trim() || 'Your prize';
      var coupon = String(res.klaviyo_coupon_id || '').trim();
      var st = { code: res.code || '', expires_at: res.expires_at || '', label: label, coupon: coupon };
      haltSpin(-1);
      var stored = { label: label, klaviyo_coupon_id: coupon || 'stored' }; // non-blank so it is not read as a no-prize
      if (st.code && storedCodeLive(st)) {
        showResult(-1, st.code, st.expires_at, alreadySpun, stored, true);
      } else {
        // No live code to show. Say so plainly, never "check your inbox".
        stored.result_text = st.code
          ? 'You have already spun. This code has now expired or been used.'
          : 'You have already spun. If you cannot find your code, contact us and we will resend it.';
        showResult(-1, '', null, true, stored, true);
      }
      showView('won');
    }

    function openPopupSmart() {
      var s = loadState();
      var st = spunState();
      var idx = -1;
      if (st === 'won' || st === 'noprize') {
        idx = resolveStoredIndex(s, st);
      }

      openPopup();

      // A result saved before the backend sent the prize's identity (no
      // state_v) is not replayed: its coupon and label may belong to whatever
      // sat at their old wedge position, or to the NO PRIZE stand-in slot. The
      // entry form stays up; re-entering the email re-resolves the prize.
      if ((st === 'won' || st === 'noprize') && !stateTrusted(s)) return;
      // Never render a win for a state that says no prize, or on a wedge that
      // carries no coupon (showResult would bail and leave the unrendered
      // "You won" markup on screen).
      if (st === 'won' && s.no_prize === true) return;
      if (st === 'won' && !String(s.coupon || '').trim() && labelNamesNoPrize(s.label)) return;
      if (st === 'won' && idx >= 0 && !(prizes[idx] && prizes[idx].klaviyo_coupon_id)) return;

      // Won, but the prize isn't on the wheel any more: render it from state.
      // If that isn't possible (legacy state with no stored label) fall through
      // and show nothing, re-entering their email re-spins, and the backend
      // returns the real prize off the Spins sheet, so it self-heals.
      if (st === 'won' && idx < 0) {
        showStoredWin(s);
        return;
      }
      if (st === 'noprize' && idx < 0) {
        setNoPrizeCopy(!!(s && s.already_spun));
        showView('noprize');
        return;
      }
      if (idx < 0) return;

      // No-prize: jump straight to the consolation view. No deceleration
      // animation needed (we're not pretending they spun again).
      if (st === 'noprize') {
        // Snap the wheel to the NO-PRIZE slice they actually landed on,
        // exactly like the won path below. Without this the wheel sits at
        // its pre-spin rest position (pointer near a winning slice) next to
        // a "better luck next time" message, which reads as if the wheel
        // landed on a prize but said no.
        try {
          stopNotchTracking();
          rotGroup.classList.remove('is-looping');
          rotGroup.style.animationDelay = '';
          rotGroup.style.transition = 'none';
          var sliceCentreNp = idx * sliceAngle + sliceAngle / 2;
          var landingRotNp = (360 - sliceCentreNp) % 360;
          rotGroup.style.transform = 'rotate(' + landingRotNp + 'deg)';
          rotGroup.getBoundingClientRect();
        } catch (e) {}
        try { showResult(idx, '', null, true); } catch (e) {}
        setNoPrizeCopy(!!(s && s.already_spun));
        showView('noprize');
        return;
      }

      // Won path: snap the wheel to the winning slice and render the
      // won view with the stored code.

      try {
        stopNotchTracking();
        rotGroup.classList.remove('is-looping');
        rotGroup.style.animationDelay = '';
        rotGroup.style.transition = 'none';
        var sliceCentre = idx * sliceAngle + sliceAngle / 2;
        var landingRot = (360 - sliceCentre) % 360;
        rotGroup.style.transform = 'rotate(' + landingRot + 'deg)';
        rotGroup.getBoundingClientRect();
      } catch (e) {}

      // Render the result view. showResult flips the view internally
      // to 'won' (or 'noprize'); we also force it after just in case
      // an exception inside showResult killed it before the switch.
      try {
        // Trusted state resolved to its own coupon's wedge: their own code.
        showResult(idx, s.code, s.expires_at, true, null, true);
      } catch (err) {
        if (window.console) console.error('[AG Spin Wheel] showResult failed:', err);
      }
      // Belt-and-braces: if we got here with a valid code + slice,
      // the user expects the won view regardless.
      showView('won');
    }

    [stickyLeft, stickyRight].forEach(function (el) {
      if (!el) return;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openPopupSmart();
      });
    });
    function activeStickyEls() {
      var els = [];
      if (STICKY_POSITION === 'left' || STICKY_POSITION === 'both') {
        if (stickyLeft) els.push(stickyLeft);
      }
      if (STICKY_POSITION === 'right' || STICKY_POSITION === 'both') {
        if (stickyRight) els.push(stickyRight);
      }
      return els;
    }
    function maybeShowSticky() {
      if (!SHOW_STICKY) return;
      // Don't show if popup is already open or audience-gated out.
      if (root.classList.contains('is-open')) return;
      if (outsideAudience() || notFirstTime()) return;
      // Michael 2026-10-01: "can it be hidden if they got no prize?" A visitor
      // whose spin won nothing has nothing waiting, so the pill stays away for
      // them. Winners keep "View your code"; visitors who have not spun keep
      // the pre-spin pill.
      if (spunState() === 'noprize') { hideSticky(); return; }
      activeStickyEls().forEach(function (el) {
        el.hidden = false;
        void el.offsetWidth; // force reflow so the .is-visible transition runs
        el.classList.add('is-visible');
      });
    }
    function hideSticky() {
      [stickyLeft, stickyRight].forEach(function (el) {
        if (!el) return;
        el.classList.remove('is-visible');
        setTimeout(function () { el.hidden = true; }, 320);
      });
    }
    // Hide sticky whenever popup opens (existing data-ag-sw-open
    // handler reopens the popup, but we want the pill to vanish).
    // Also pre-warm the Apps Script /exec endpoint. Apps Script
    // goes cold after ~5 min idle and the first call after that
    // pays a 1-2s spin-up tax. Firing a tiny GET when the popup
    // opens means by the time the user finishes typing their email,
    // the script is hot and the spin response is much faster.
    // Fire-and-forget: we don't read the response and we ignore
    // failures (no-cors mode keeps it out of the console).
    var prewarmedAt = 0;
    function prewarmEndpoint() {
      if (!ENDPOINT) return;
      // Apps Script stays warm for ~5 min; re-warm if last warmup
      // was more than 4 min ago (a margin under the cold threshold).
      var now = Date.now();
      if (now - prewarmedAt < 4 * 60 * 1000) return;
      prewarmedAt = now;
      try {
        fetch(ENDPOINT, { method: 'GET', mode: 'no-cors', cache: 'no-store', keepalive: true })
          .catch(function () {});
      } catch (e) {}
    }
    var oldOpenPopup = openPopup;
    openPopup = function () {
      hideSticky();
      prewarmEndpoint();
      oldOpenPopup();
    };
    // Also warm when the user focuses the email field, covers the
    // case where the popup was opened minutes ago but they're only
    // now committing to spinning.
    var prewarmEmailInput = root.querySelector('input[name="email"]');
    if (prewarmEmailInput) {
      prewarmEmailInput.addEventListener('focus', prewarmEndpoint);
    }

    // ── Web Audio (subtle tick + ding) ────────────────────────────────
    // Generated tones, no external assets. Started lazily so we don't
    // ever construct an AudioContext until the user actually interacts.
    var audioCtx = null;
    // Sound is off by default (it used to play a 'no prize' sound in public). When the theme
    // allows sound, a speaker button turns it on, and the choice is remembered.
    var SOUND_KEY = 'ag_sw_sound_on';
    var soundOn = false;
    try { soundOn = localStorage.getItem(SOUND_KEY) === '1'; } catch (e) {}
    var soundBtn = root.querySelector('[data-ag-sw-sound]');
    function paintSound() {
      if (!soundBtn) return;
      soundBtn.hidden = !ENABLE_AUDIO;
      soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      soundBtn.setAttribute('aria-label', soundOn ? 'Turn sound off' : 'Turn sound on');
      soundBtn.classList.toggle('is-on', soundOn);
    }
    if (soundBtn) {
      paintSound();
      soundBtn.addEventListener('click', function () {
        soundOn = !soundOn;
        try { localStorage.setItem(SOUND_KEY, soundOn ? '1' : '0'); } catch (e) {}
        paintSound();
      });
    }
    function getAudio() {
      if (!ENABLE_AUDIO || !soundOn) return null;
      if (audioCtx) return audioCtx;
      try {
        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      } catch (e) { audioCtx = null; }
      return audioCtx;
    }
    function playTone(freq, durationMs, type, gain) {
      var ctx = getAudio();
      if (!ctx) return;
      var osc = ctx.createOscillator();
      var g = ctx.createGain();
      osc.type = type || 'sine';
      osc.frequency.value = freq;
      g.gain.value = gain || 0.05;
      // Quick fade out for a soft tick / ding rather than a beep
      g.gain.setValueAtTime(g.gain.value, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + (durationMs / 1000));
      osc.connect(g); g.connect(ctx.destination);
      osc.start();
      osc.stop(ctx.currentTime + (durationMs / 1000));
    }
    function playTick() { playTone(1200, 40, 'square', 0.04); }
    function playDing() {
      // Two-note major third for a "win" feel
      playTone(880, 220, 'sine', 0.08);
      setTimeout(function () { playTone(1108, 380, 'sine', 0.07); }, 120);
    }
    // Classic 'wah-wah-wah-waaaah' losing-horn for no-prize spins.
    // Three short brassy notes descending, then a longer note that
    // glides down a few semitones to nail the deflated feeling.
    function playSadTrombone() {
      var ctx = getAudio();
      if (!ctx) return;
      var t0 = ctx.currentTime;
      // F3, E3, Eb3, the three short 'wah's
      var shortNotes = [
        { freq: 174.61, start: 0.00, dur: 0.18 },
        { freq: 164.81, start: 0.20, dur: 0.18 },
        { freq: 155.56, start: 0.40, dur: 0.18 }
      ];
      shortNotes.forEach(function (n) {
        var osc = ctx.createOscillator();
        var g = ctx.createGain();
        osc.type = 'sawtooth';
        osc.frequency.value = n.freq;
        g.gain.value = 0.07;
        g.gain.setValueAtTime(0.07, t0 + n.start);
        g.gain.exponentialRampToValueAtTime(0.0001, t0 + n.start + n.dur);
        osc.connect(g); g.connect(ctx.destination);
        osc.start(t0 + n.start);
        osc.stop(t0 + n.start + n.dur + 0.02);
      });
      // Final 'waaaaaaah'. D3 sliding down to A2 over 0.7s
      var finalOsc = ctx.createOscillator();
      var finalGain = ctx.createGain();
      finalOsc.type = 'sawtooth';
      finalOsc.frequency.setValueAtTime(146.83, t0 + 0.62);   // D3
      finalOsc.frequency.linearRampToValueAtTime(110.00, t0 + 1.30); // A2
      finalGain.gain.setValueAtTime(0.08, t0 + 0.62);
      finalGain.gain.exponentialRampToValueAtTime(0.0001, t0 + 1.32);
      finalOsc.connect(finalGain); finalGain.connect(ctx.destination);
      finalOsc.start(t0 + 0.62);
      finalOsc.stop(t0 + 1.34);
    }

    function showView(name) {
      root.querySelectorAll('[data-ag-sw-view]').forEach(function (v) {
        v.hidden = (v.getAttribute('data-ag-sw-view') !== name);
      });
    }

    // ── Trigger logic ─────────────────────────────────────────────────
    var triggered = false;
    // Set once the wheel has already waited for the header store-choice
    // prompt, so a hung prompt check can only delay the wheel once.
    var storePromptWaited = false;
    // True (and waits) while the header store-choice prompt is deciding or
    // showing; resumes triggerOnce when it settles, capped at 15 s.
    function waitForStorePrompt() {
      if (storePromptWaited) return false;
      var sp = document.documentElement.getAttribute('data-store-prompt');
      if (sp !== 'pending' && sp !== 'open') return false;
      storePromptWaited = true;
      var resumed = false;
      var resume = function () {
        if (resumed) return;
        resumed = true;
        window.removeEventListener('crossstore:done', resume);
        setTimeout(triggerOnce, 1500);
      };
      window.addEventListener('crossstore:done', resume);
      setTimeout(resume, 15000);
      return true;
    }
    // Never auto-open if the popup is already open, re-opening calls
    // resetWheelRotation() which would clobber an in-flight spin.
    function triggerOnce() {
      if (triggered || root.classList.contains('is-open')) return;
      // Gate the AUTO trigger: wait for cookie consent, and stand down if
      // another popup is open (coordinator). Manual reopen (sticky pill) is
      // NOT gated, it calls openPopup() directly.
      if (window.AGPopups) {
        window.AGPopups.whenConsent(function () {
          if (triggered || root.classList.contains('is-open')) return;
          if (waitForStorePrompt()) return;
          if (!window.AGPopups.canAutoOpen()) return;
          triggered = true; openPopup();
        });
      } else {
        triggered = true; openPopup();
      }
    }

    // Stable hash of device ID → 0..99 bucket. Used for A/B traffic
    // splitting so the same visitor consistently sees (or doesn't see)
    // the popup across page loads.
    function deviceBucket() {
      var id = getOrCreateDeviceId();
      var h = 0;
      for (var i = 0; i < id.length; i++) {
        h = ((h << 5) - h) + id.charCodeAt(i);
        h = h & h; // 32-bit
      }
      return Math.abs(h) % 100;
    }

    // Returns true if the visitor falls outside the configured
    // audience % bucket, they should never see the popup.
    function outsideAudience() {
      if (AUDIENCE_PCT >= 100) return false;
      if (AUDIENCE_PCT <= 0) return true;
      return deviceBucket() >= AUDIENCE_PCT;
    }

    // Returns true if 'first-time only' is on AND we've seen this
    // device before (any state stamped).
    function notFirstTime() {
      if (!FIRST_TIME_ONLY) return false;
      var s = loadState();
      return !!(s && (s.lastSpunAt || s.lastDismissedAt));
    }

    // Ad-landing hold. Clarity (Sep 2026): the wheel was the first thing most
    // paid visitors touched, 10 to 40 s on it before any product tap, and paid
    // Meta sessions had the lowest active time on the site. When a session
    // arrived from an ad, hold the timed trigger until the visitor is on page
    // N of that session, or has spent PAID_HOLD_SECONDS on the landing page.
    // Exit-intent and the manual button are untouched. Session-scoped so a
    // returning direct visit is not held.
    var PAID_KEY = 'ag_sw_paid';
    var PV_KEY = 'ag_sw_pv';
    function sessionGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
    function sessionSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
    function landedFromAd() {
      var q = window.location.search || '';
      if (/[?&](fbclid|gclid|gbraid|wbraid|ttclid|msclkid|dclid)=/i.test(q)) return true;
      var m = q.match(/[?&]utm_medium=([^&]*)/i);
      if (!m) return false;
      var medium = decodeURIComponent(m[1].replace(/\+/g, ' ')).toLowerCase();
      return /^(paid|cpc|ppc|cpm|display|paid[-_ ]?social|social[-_ ]?paid|retargeting)$/.test(medium);
    }
    function trackPaidSession() {
      var pv = parseInt(sessionGet(PV_KEY), 10) || 0;
      pv += 1;
      sessionSet(PV_KEY, String(pv));
      if (landedFromAd()) sessionSet(PAID_KEY, '1');
      return pv;
    }
    // Returns the delay in seconds for the timed trigger, or -1 to skip it on
    // this page view.
    function timedDelayForThisPage() {
      var pv = trackPaidSession();
      if (!PAID_HOLD || sessionGet(PAID_KEY) !== '1') return TRIGGER_DELAY;
      if (pv >= PAID_HOLD_PAGES) return TRIGGER_DELAY;
      if (PAID_HOLD_SECONDS > 0) return Math.max(TRIGGER_DELAY, PAID_HOLD_SECONDS);
      return -1;
    }

    function setupTriggers() {
      if (outsideAudience()) return;
      if (notFirstTime()) return;
      // Already spun, permanent suppression of the auto-trigger.
      // Sticky tab is the only path back into the popup for them.
      if (hasSpun()) {
        maybeShowSticky();
        return;
      }
      if (isCoolingDown()) {
        // Engaged before but didn't spin, popup hibernates for the
        // cooldown period, sticky stays visible. Popup auto-triggers
        // again once cooldown_days has elapsed.
        maybeShowSticky();
        return;
      }

      if (TRIGGER === 'manual') {
        // Open via [data-ag-sw-open] button anywhere on the page
        document.addEventListener('click', function (e) {
          var t = e.target.closest && e.target.closest('[data-ag-sw-open]');
          if (t) { e.preventDefault(); openPopup(); }
        });
        return;
      }

      if (TRIGGER === 'timed' || TRIGGER === 'both') {
        var timedDelay = timedDelayForThisPage();
        if (timedDelay >= 0) setTimeout(triggerOnce, timedDelay * 1000);
      }
      if (TRIGGER === 'exit' || TRIGGER === 'both') {
        var exitHandler = function (e) {
          // Mouse leaving viewport from the top counts as exit-intent on desktop
          if (e.clientY <= 0) {
            triggerOnce();
            document.removeEventListener('mouseout', exitHandler);
          }
        };
        document.addEventListener('mouseout', exitHandler);
      }
      // Manual button still works as a fallback
      document.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('[data-ag-sw-open]');
        if (t) { e.preventDefault(); openPopup(); }
      });
    }
    setupTriggers();

    // Test mode: auto-open to the spin view, prefill the last test email,
    // and show a banner so the tester knows the gates are bypassed and
    // which prize is being forced.
    if (TEST_MODE) {
      try {
        triggered = true; // we're opening directly, suppress the scheduled auto-trigger so it can't reset the wheel mid-spin
        openPopup();
        var _te = '';
        try { _te = localStorage.getItem(TEST_EMAIL_KEY) || ''; } catch (e) {}
        var _ei = root.querySelector('input[name="email"]');
        if (_ei && _te) _ei.value = _te;
        var _forced = (FORCE_PRIZE_INDEX >= 0)
          ? ('forcing prize #' + FORCE_PRIZE_INDEX + (prizes[FORCE_PRIZE_INDEX] ? ' (' + (prizes[FORCE_PRIZE_INDEX].label || '') + ')' : ''))
          : 'random prize (add &ag_sw_prize=N to force one)';
        var _badge = document.createElement('div');
        _badge.textContent = 'SPIN WHEEL TEST MODE: ' + _forced + ' · once-per-email/cooldown bypassed';
        _badge.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:100000;background:#c8102e;color:#fff;font:700 12px/1.4 system-ui,sans-serif;text-align:center;padding:6px 10px;letter-spacing:.04em;';
        document.body.appendChild(_badge);
      } catch (e) {}
    }

    // ── Theme editor preview helpers ──────────────────────────────────
    // In the Shopify theme editor, two merchant-controlled toggles plus
    // block selection drive what the popup shows:
    //   - Section "Show popup in theme editor" toggle: forces the popup
    //     open / closed so they can edit other parts of the page
    //     unblocked.
    //   - Each slice's "Show this slice's win view (editor only)"
    //     toggle: when ticked, popup jumps to that slice's win view
    //     so per-tier copy can be edited without spinning.
    //   - Selecting a slice block in the editor sidebar also previews
    //     it (existing behaviour preserved).
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    var FORCE_SHOW_POPUP = root.dataset.previewShowPopup !== '0';
    if (inEditor) {
      // Delay slightly so the section finishes rendering first
      if (FORCE_SHOW_POPUP) {
        setTimeout(function () {
          if (!root.classList.contains('is-open')) openPopup();
          // Then check if any slice has the win-preview toggle on
          setTimeout(applyForcedSliceWin, 250);
        }, 200);
      }

      function applyForcedSliceWin() {
        for (var i = 0; i < prizes.length; i++) {
          if (prizes[i].preview_show_win) {
            previewSliceWin(prizes[i].block_id);
            return;
          }
        }
      }

      function previewSliceWin(blockId) {
        var idx = -1;
        for (var i = 0; i < prizes.length; i++) {
          if (prizes[i].block_id === blockId) { idx = i; break; }
        }
        // Not one of OUR slice blocks, ignore (some other section's
        // block was selected).
        if (idx < 0) return;

        if (!root.classList.contains('is-open')) openPopup();

        // Snap the wheel directly to the slice's landing position
        // (no spin animation in preview).
        stopNotchTracking();
        rotGroup.classList.remove('is-looping');
        rotGroup.style.animationDelay = '';
        rotGroup.style.transition = 'none';
        var sliceCentre = idx * sliceAngle + sliceAngle / 2;
        var landingRot = (360 - sliceCentre) % 360;
        rotGroup.style.transform = 'rotate(' + landingRot + 'deg)';
        rotGroup.getBoundingClientRect();

        // Render the result view immediately. For no-prize slices
        // showResult routes to the consolation view automatically.
        var placeholderCode = 'PREVIEW-' + (prizes[idx].label || 'SLICE')
          .toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
        showResult(idx, placeholderCode, null, false);
      }

      // Shopify fires shopify:block:select with the selected block's ID
      // in event.detail.blockId. We don't need to gate on which section
      // fired it, previewSliceWin returns early if the blockId doesn't
      // belong to this section's prizes.
      document.addEventListener('shopify:block:select', function (e) {
        if (e && e.detail && e.detail.blockId) {
          previewSliceWin(e.detail.blockId);
        }
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        if (!e || !e.detail || !e.detail.blockId) return;
        // Only react if the deselected block belongs to this section
        var matches = false;
        for (var i = 0; i < prizes.length; i++) {
          if (prizes[i].block_id === e.detail.blockId) { matches = true; break; }
        }
        if (!matches) return;
        if (root.classList.contains('is-open')) {
          showView('enter');
          resetWheelRotation();
        }
      });
    }

    // ── Close handlers ────────────────────────────────────────────────
    root.querySelectorAll('[data-ag-sw-close], [data-ag-sw-close-btn]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    // Shop Now CTA, for slices configured to "stay on current page",
    // close the popup instead of navigating.
    root.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-ag-sw-shop-close]');
      if (t) { e.preventDefault(); closePopup(); }
    });
    var backdrop = root.querySelector('[data-ag-sw-backdrop]');
    if (backdrop) backdrop.addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') closePopup();
    });

    // ── Submit handler ────────────────────────────────────────────────
    var form = root.querySelector('[data-ag-sw-form]');
    var submitBtn = root.querySelector('[data-ag-sw-submit]');
    var ctaLabel = root.querySelector('[data-ag-sw-cta-label]');

    function pickPrizeLocally() {
      // Demo / fallback: weighted-random pick client-side
      var totalWeight = 0;
      for (var i = 0; i < prizes.length; i++) totalWeight += Math.max(0, parseFloat(prizes[i].weight) || 0);
      if (totalWeight <= 0) totalWeight = prizes.length;
      var r = Math.random() * totalWeight;
      var cum = 0;
      for (var j = 0; j < prizes.length; j++) {
        cum += Math.max(0, parseFloat(prizes[j].weight) || 0) || 1;
        if (r <= cum) return j;
      }
      return prizes.length - 1;
    }

    // Validate slice weights at boot. Surfaces config issues early so a
    // merchant doesn't silently ship a wheel where some slices can't be
    // hit. Logs to console (always) and shows an editor-only banner.
    (function validateWeights() {
      var rows = [];
      var total = 0;
      // High-value slices are rolled SERVER-SIDE at a fixed rarity (see
      // HIGH_VALUE_ODDS in ag-spin-wheel-script/Code.js) and are excluded from the
      // wheel's weighted pick, so their slice weight is 0/display-only and
      // weight÷total would read a misleading 0%. Map coupon id → true odds
      // (1-in-N) so the editor panel shows the real chance. KEEP IN SYNC with
      // HIGH_VALUE_ODDS (0.000667 = 1 in 1500).
      var SERVER_ODDS = { 'Spin_50Off': 1500 };
      for (var i = 0; i < prizes.length; i++) {
        var w = parseFloat(prizes[i].weight);
        if (!isFinite(w) || w < 0) w = 0;
        rows.push({ idx: i, label: prizes[i].label || ('Slice ' + (i + 1)), weight: w });
        total += w;
      }
      var problems = [];
      if (total <= 0) {
        problems.push('Total weight is 0. No slice can ever win. Set at least one slice weight > 0.');
      }
      var zeroWinners = [];
      var tinyWinners = [];
      for (var k = 0; k < rows.length; k++) {
        var r = rows[k];
        var hasCoupon = !!(prizes[r.idx].klaviyo_coupon_id);
        if (r.weight <= 0 && hasCoupon && !SERVER_ODDS[prizes[r.idx].klaviyo_coupon_id]) {
          zeroWinners.push(r.label);
        } else if (total > 0 && r.weight > 0 && (r.weight / total) < 0.0005 && hasCoupon) {
          tinyWinners.push(r.label + ' (' + ((r.weight / total) * 100).toFixed(2) + '%)');
        }
      }
      if (zeroWinners.length) {
        problems.push('Winning slices with weight 0 (impossible to hit): ' + zeroWinners.join(', '));
      }
      if (tinyWinners.length) {
        problems.push('Winning slices below 0.05% chance: ' + tinyWinners.join(', '));
      }
      // Log the % breakdown ONLY in design mode (theme editor), was
      // firing on every public page-load otherwise, polluting customers'
      // consoles and any merchant doing a live audit.
      var _isDesignMode = !!(window.Shopify && window.Shopify.designMode);
      if (_isDesignMode && window.console && console.table && total > 0) {
        var breakdown = rows.map(function (r) {
          return {
            slice: r.label,
            weight: r.weight,
            chance: ((r.weight / total) * 100).toFixed(2) + '%'
          };
        });
        try { console.groupCollapsed('[AG Spin Wheel] Slice probabilities'); } catch (e) {}
        try { console.table(breakdown); } catch (e) {}
        try { console.groupEnd(); } catch (e) {}
      }
      if (_isDesignMode && problems.length && window.console) {
        console.warn('[AG Spin Wheel] Configuration warnings:\n  • ' + problems.join('\n  • '));
      }
      // Editor-only inline panel so the merchant sees the live %
      // breakdown plus any warnings without opening DevTools. Re-renders
      // every time the section re-injects (Shopify does this on every
      // settings change), so the % updates as you tweak weights. Can
      // be hidden via section setting if it gets in the way of editing.
      var SHOW_EDITOR_PROBS = root.dataset.showEditorProbs !== '0';
      // Always remove any prior panel first, handles both re-render
      // (settings changed) and toggle-off (preference switched off
      // since last render).
      var priorPanelId = 'ag-sw-editor-panel-' + ID_BASE;
      var prior = document.getElementById(priorPanelId);
      if (prior) prior.remove();

      if (window.Shopify && window.Shopify.designMode && SHOW_EDITOR_PROBS) {
        var panel = document.createElement('div');
        panel.id = priorPanelId;
        panel.setAttribute('role', 'region');
        panel.setAttribute('aria-label', 'Spin Wheel slice probabilities');
        panel.style.cssText = 'position:fixed;right:12px;bottom:12px;z-index:99999;max-width:380px;background:#1a1a1a;color:#f4f4f4;border:1px solid #333;border-radius:8px;padding:12px 14px;font:12px/1.4 system-ui,-apple-system,sans-serif;box-shadow:0 6px 24px rgba(0,0,0,0.4);';

        var header = '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;gap:8px;">' +
          '<strong style="color:#ff4d4d;letter-spacing:0.04em;text-transform:uppercase;font-size:11px;">Spin Wheel: chances</strong>' +
          '<span style="opacity:0.5;font-size:11px;">total weight ' + total + '</span>' +
          '</div>';

        // Format chance as a high-precision %. Trims trailing zeros so
        // 12.5000% renders as 12.5%, but keeps significant digits for
        // tiny values (e.g. 0.0010% rather than 0%).
        function fmtPct(pct) {
          if (pct <= 0) return '0%';
          var n;
          if (pct >= 1)         n = pct.toFixed(2);   // 12.50
          else if (pct >= 0.01) n = pct.toFixed(4);   // 0.5000
          else if (pct >= 0.0001) n = pct.toFixed(6); // 0.001000
          else                  n = pct.toExponential(2); // 1.00e-5
          // Trim trailing zeros after the decimal (but keep '12' not '12.')
          if (n.indexOf('.') >= 0 && n.indexOf('e') < 0) {
            n = n.replace(/0+$/, '').replace(/\.$/, '');
          }
          return n + '%';
        }
        // 1-in-N format. Returns '-' when chance is 0 or unknown.
        function fmtOneIn(weight, total) {
          if (weight <= 0 || total <= 0) return '-';
          var ratio = total / weight;
          if (ratio < 2) return '~1 in ' + ratio.toFixed(2);
          if (ratio < 1000) return '1 in ' + Math.round(ratio).toLocaleString();
          // For very large ratios, still useful to read at a glance
          return '1 in ' + Math.round(ratio).toLocaleString();
        }

        var tableRows = rows.map(function (r) {
          var hasCoupon = !!(prizes[r.idx].klaviyo_coupon_id);
          var serverN = SERVER_ODDS[prizes[r.idx].klaviyo_coupon_id] || 0;
          // Server-gated slice: show its true fixed odds, not weight÷total (0%).
          var pct = serverN ? (100 / serverN) : (total > 0 ? (r.weight / total) * 100 : 0);
          var pctStr = serverN ? fmtPct(pct) : (total > 0 ? fmtPct(pct) : '-');
          var oneInStr = serverN ? ('1 in ' + serverN.toLocaleString()) : fmtOneIn(r.weight, total);
          var rowColor = '#f4f4f4';
          if (serverN) rowColor = '#f4f4f4';
          else if (r.weight <= 0) rowColor = '#888';
          else if (hasCoupon && pct < 0.5) rowColor = '#ffb84d';
          var dot = '<span style="display:inline-block;width:8px;height:8px;border-radius:50%;margin-right:6px;background:' + (hasCoupon ? '#4dd06b' : '#666') + ';"></span>';
          var safeLabel = (r.label || '').replace(/</g, '&lt;');
          if (serverN) safeLabel += ' <span style="opacity:0.5;font-size:10px;">· server</span>';
          return '<tr style="color:' + rowColor + ';">' +
            '<td style="padding:2px 6px 2px 0;white-space:nowrap;">' + dot + safeLabel + '</td>' +
            '<td style="padding:2px 6px;text-align:right;opacity:0.7;font-variant-numeric:tabular-nums;">' + r.weight + '</td>' +
            '<td style="padding:2px 6px;text-align:right;font-variant-numeric:tabular-nums;font-weight:600;">' + pctStr + '</td>' +
            '<td style="padding:2px 0;text-align:right;opacity:0.85;font-variant-numeric:tabular-nums;white-space:nowrap;">' + oneInStr + '</td>' +
            '</tr>';
        }).join('');

        var table = '<table style="width:100%;border-collapse:collapse;margin-bottom:6px;">' +
          '<thead><tr style="opacity:0.5;font-size:10px;text-transform:uppercase;letter-spacing:0.05em;">' +
          '<th style="text-align:left;padding:0 6px 4px 0;font-weight:500;">Slice</th>' +
          '<th style="text-align:right;padding:0 6px 4px;font-weight:500;">W</th>' +
          '<th style="text-align:right;padding:0 6px 4px;font-weight:500;">Chance</th>' +
          '<th style="text-align:right;padding:0 0 4px;font-weight:500;">Odds</th>' +
          '</tr></thead><tbody>' + tableRows + '</tbody></table>';

        var legend = '<div style="opacity:0.5;font-size:10px;margin-bottom:' + (problems.length ? '8px' : '0') + ';">' +
          '<span style="color:#4dd06b;">●</span> winning slice &nbsp;' +
          '<span style="color:#666;">●</span> no prize &nbsp;·&nbsp; ' +
          'Hide via section setting' +
          '</div>';

        var problemBlock = '';
        if (problems.length) {
          problemBlock = '<div style="border-top:1px solid #333;padding-top:8px;margin-top:4px;">' +
            '<strong style="display:block;margin-bottom:4px;color:#ff8888;font-size:11px;">Warnings</strong>' +
            '<ul style="margin:0;padding-left:16px;color:#ffd6d6;">' +
            problems.map(function (p) { return '<li>' + p.replace(/</g, '&lt;') + '</li>'; }).join('') +
            '</ul></div>';
        }

        panel.innerHTML = header + table + legend + problemBlock;
        document.body.appendChild(panel);
      }
    })();

    // How long to wait for the spin backend before giving up. On a flaky
    // mobile network the fetch can stall with no response at all; without a
    // hard timeout the returned promise never settles, Promise.all() below
    // never resolves, and the wheel loops forever (reported: "just keeps
    // spinning", mobile only). The warm backend answers in <3s and the wheel
    // pre-warms it on open, so 15s only ever trips on a genuine stall.
    var SPIN_FETCH_TIMEOUT_MS = 15000;

    function callBackend(payload) {
      if (!ENDPOINT || !TOKEN) return Promise.resolve(null);
      var body = JSON.stringify(Object.assign({ action: 'spin', token: TOKEN }, payload));
      var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, SPIN_FETCH_TIMEOUT_MS) : null;
      var clear = function () { if (timer) { clearTimeout(timer); timer = null; } };
      return fetch(ENDPOINT, {
        method: 'POST',
        body: body,
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        redirect: 'follow',
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (r) {
        clear();
        // A truthy Response is not a successful one, a 4xx/5xx (or an
        // HTML cold-start/redirect page) must not be parsed as a prize.
        if (!r.ok) throw new Error('spin backend HTTP ' + r.status);
        return r.json();
      }).catch(function (e) {
        clear();
        throw e; // aborted / offline / bad status -> caller shows the error view
      });
    }

    function getCurrentRotationDeg() {
      // The wheel is JS-driven now (spinAngle), so just return its angle.
      return ((spinAngle % 360) + 360) % 360;
    }

    // ── rAF-driven spin ───────────────────────────────────────────────
    // Driven entirely by requestAnimationFrame writing an inline
    // transform. NOT a CSS @keyframes animation. The CSS loop wasn't
    // reliably engaging during the (now ~1–2s) backend wait, so the
    // wheel sat still mid-spin. JS-driving guarantees continuous motion
    // until the backend responds, then a smooth eased landing.
    var LOOP_SPEED_DEG_PER_S = 720;   // spin speed (deg/s) during the wait
    var spinRAF = null;
    var spinAngle = 0;                // accumulated degrees (unbounded)
    var spinPhase = 'idle';           // 'pullback' | 'loop' | 'decel'
    var spinLastTs = 0;
    var pullbackInfo = null;
    var decelInfo = null;
    var phaseBTimer = null;           // legacy ref kept for old call-sites
    var REDUCED_MOTION = false;
    try { REDUCED_MOTION = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}

    function applyWheelAngle(a) { rotGroup.style.transform = 'rotate(' + a + 'deg)'; }

    function cancelSpin() {
      if (spinRAF) cancelAnimationFrame(spinRAF);
      spinRAF = null;
      spinPhase = 'idle';
    }

    function spinFrame(ts) {
      if (!spinLastTs) spinLastTs = ts;
      var dt = (ts - spinLastTs) / 1000;
      if (dt > 0.1) dt = 0.1;   // clamp big gaps (tab blur) so it can't jump
      spinLastTs = ts;
      if (spinPhase === 'pullback') {
        var pe = Math.min(1, (ts - pullbackInfo.start) / pullbackInfo.dur);
        var pEased = 1 - Math.pow(1 - pe, 2);
        spinAngle = pullbackInfo.from + (pullbackInfo.to - pullbackInfo.from) * pEased;
        applyWheelAngle(spinAngle);
        if (pe >= 1) spinPhase = 'loop';
      } else if (spinPhase === 'loop') {
        spinAngle += LOOP_SPEED_DEG_PER_S * dt;
        applyWheelAngle(spinAngle);
      } else if (spinPhase === 'decel') {
        var de = Math.min(1, (ts - decelInfo.start) / decelInfo.dur);
        var dEased = 1 - Math.pow(1 - de, 3);   // easeOutCubic
        spinAngle = decelInfo.from + (decelInfo.to - decelInfo.from) * dEased;
        applyWheelAngle(spinAngle);
        if (de >= 1) { cancelSpin(); if (decelInfo.onDone) decelInfo.onDone(); return; }
      }
      spinRAF = requestAnimationFrame(spinFrame);
    }

    function startSpinLoop() {
      cancelSpin();
      spinAngle = (typeof STARTING_ROTATION === 'number' ? STARTING_ROTATION : 0);
      spinLastTs = 0;
      decelInfo = null;
      rotGroup.classList.remove('is-looping');
      rotGroup.style.animationDelay = '';
      rotGroup.style.transition = 'none';
      applyWheelAngle(spinAngle);
      startNotchTracking();
      if (REDUCED_MOTION) { spinPhase = 'idle'; return; } // no spin; lands instantly
      // brief pullback flourish (-90°) then a continuous forward loop
      pullbackInfo = { from: spinAngle, to: spinAngle - 90, start: performance.now(), dur: 450 };
      spinPhase = 'pullback';
      spinRAF = requestAnimationFrame(spinFrame);
    }

    // Decelerate from the current angle to land on the prize. Returns the
    // deceleration duration in ms so the caller can time the reveal.
    function endLoopAndLand(prizeIndex) {
      var current = spinAngle;
      var sliceCentre = prizeIndex * sliceAngle + sliceAngle / 2;
      var landingPos = (360 - sliceCentre) % 360;

      if (REDUCED_MOTION) {
        // No spin for reduced-motion users, snap to the slice.
        spinAngle = landingPos;
        applyWheelAngle(spinAngle);
        setTimeout(stopNotchTracking, 100);
        return 250;
      }

      var minExtraSpin = 360; // ~1 extra turn so the landing reads as a real spin
      var raw = current + minExtraSpin;
      var rawMod = ((raw % 360) + 360) % 360;
      var addToReach = (landingPos - rawMod + 360) % 360;
      var target = raw + addToReach;
      var distance = target - current;
      // easeOutCubic has initial slope 3, so duration = 3*distance/speed
      // makes the deceleration START at exactly the loop speed, no
      // speed-up jolt at the loop->decel handoff. Clamped short so the
      // landing feels snappy.
      var decelDuration = Math.max(1.0, Math.min(1.8, (distance / LOOP_SPEED_DEG_PER_S) * 3));

      decelInfo = { from: current, to: target, start: performance.now(), dur: decelDuration * 1000, onDone: null };
      spinPhase = 'decel';
      spinLastTs = 0;
      if (!spinRAF) spinRAF = requestAnimationFrame(spinFrame);

      setTimeout(stopNotchTracking, decelDuration * 1000 + 100);
      return decelDuration * 1000;
    }

    var STARTING_ROTATION = parseInt(root.dataset.startingRotation, 10) || 0;

    function resetWheelRotation() {
      // Never reset while a spin is in flight, that would snap the
      // wheel back to the start angle and break the loop->decel handoff.
      if (spinPhase !== 'idle') return;
      // Snap the wheel back to its rest position. No animation.
      cancelSpin();
      spinAngle = STARTING_ROTATION;
      rotGroup.classList.remove('is-looping');
      rotGroup.style.animationDelay = '';
      rotGroup.style.transition = 'none';
      rotGroup.style.transform = 'rotate(' + STARTING_ROTATION + 'deg)';
      rotGroup.getBoundingClientRect();
      stopNotchTracking();
    }

    // ── Pointer notch (rAF tracker) ───────────────────────────────────
    // Mirrors a real wheel-of-fortune flapper: pointer flicks each time
    // a slice boundary passes underneath. Driven by requestAnimationFrame
    // reading the live computed transform.
    var POINTER_EL = root.querySelector('.ag-sw__pointer');
    var notchRAF = null;
    var lastSliceUnderPointer = -1;

    function startNotchTracking() {
      if (!POINTER_EL) return;
      lastSliceUnderPointer = -1;
      stopNotchTracking();
      var tick = function () {
        var deg = getCurrentRotationDeg();
        var pointerOrig = ((-deg) % 360 + 360) % 360;
        var slice = Math.floor(pointerOrig / sliceAngle);
        if (slice !== lastSliceUnderPointer) {
          if (lastSliceUnderPointer !== -1) flickPointer();
          lastSliceUnderPointer = slice;
        }
        notchRAF = requestAnimationFrame(tick);
      };
      notchRAF = requestAnimationFrame(tick);
    }
    function stopNotchTracking() {
      if (notchRAF) cancelAnimationFrame(notchRAF);
      notchRAF = null;
    }
    function flickPointer() {
      if (!POINTER_EL) return;
      POINTER_EL.classList.remove('is-notched');
      void POINTER_EL.offsetWidth; // force reflow so consecutive notches replay
      POINTER_EL.classList.add('is-notched');
      playTick();
    }

    // storedPrize: an {label, klaviyo_coupon_id} rebuilt from saved state, used
    // when the prize they won is no longer a slice on the wheel. It stands in for
    // prizes[prizeIndex] so the won view renders from what they ACTUALLY won.
    // Slice-only settings (result_text, shop_link_*, show_code_in_popup) are
    // absent on it, so the generic copy, the /collections/all CTA and the visible
    // code box all apply, which is right: they already hold the code.

    // ownCode: the code is this customer's own, for the prize shown, because
    // the backend sent the prize's identity and it agrees with the wedge (or
    // the view is built from that identity). Only then does a returning view
    // show the code of a show_code_in_popup:false prize.
    function showResult(prizeIndex, code, expiresAt, alreadySpun, storedPrize, ownCode) {
      var p = storedPrize || prizes[prizeIndex] || {};

      // No-prize tier: blank Klaviyo Coupon ID. Show consolation view.
      if (!p.klaviyo_coupon_id) { showView('noprize'); return; }

      var titleEl = root.querySelector('[data-ag-sw-result-title]');
      var subEl = root.querySelector('[data-ag-sw-result-subtitle]');
      var codeEl = root.querySelector('[data-ag-sw-result-code]');
      var expEl = root.querySelector('[data-ag-sw-result-expiry]');

      if (titleEl) titleEl.textContent = displayLabel(p.label);
      var codeWasReturned = !!code;
      // Per-slice setting: high-value tiers can hide the code in the
      // popup so winners must check email (extra friction = harder to
      // scrape). Defaults to true for backward compat.
      var showCode = (p.show_code_in_popup === false) ? false : true;
      // The email-only view ("check your emails") is for a win that really has
      // a code on its way, and a response with no code must never send anyone
      // to their inbox for one (2026-09-30: a No Prize spinner was landed on
      // 50% OFF and told to check his email). A returning customer is shown
      // the code they already hold, but ONLY when it is verifiably their own
      // (ownCode). An older backend's replay is not verified, so a
      // show_code_in_popup:false prize keeps the code in the email as before.
      var emailOnly = !showCode && codeWasReturned && !(alreadySpun && ownCode);

      // If the slice has custom result_text set, use it (rich text, set
      // innerHTML). Otherwise fall back to the default copy.
      if (subEl) {
        if (p.result_text) {
          subEl.innerHTML = p.result_text;
        } else if (emailOnly && codeWasReturned) {
          subEl.textContent = "Congratulations! Please check your emails for the code.";
        } else if (alreadySpun && codeWasReturned) {
          subEl.textContent = "You've already spun. Here's the code we sent. Use it once at checkout.";
        } else if (alreadySpun) {
          // No code on record: we cannot know one was ever emailed.
          subEl.textContent = "You've already spun. If you cannot find your code, contact us and we will resend it.";
        } else if (codeWasReturned) {
          subEl.textContent = "Use it once at checkout. We've also emailed it to you.";
        } else {
          // A win with no code: nothing is being emailed (the backend only
          // sends the Spun Wheel email when it holds a code), so do not say so.
          subEl.textContent = "We could not load your code just now. Contact us and we will send it to you.";
        }
      }

      // Wire up the Shop Now CTA based on this slice's settings.
      var shopBtn = root.querySelector('[data-ag-sw-shop]');
      if (shopBtn) {
        var linkType = p.shop_link_type || 'all';
        if (linkType === 'current') {
          shopBtn.setAttribute('href', '#');
          shopBtn.setAttribute('data-ag-sw-shop-close', '');
        } else if (linkType === 'custom' && p.shop_link_url) {
          shopBtn.setAttribute('href', p.shop_link_url);
          shopBtn.removeAttribute('data-ag-sw-shop-close');
        } else {
          shopBtn.setAttribute('href', '/collections/all');
          shopBtn.removeAttribute('data-ag-sw-shop-close');
        }
      }

      // Show the code box only if we have a code AND the slice
      // permits showing it in the popup. High-value tiers hide it
      // so winners are nudged to check email.
      var codeWrap = root.querySelector('[data-ag-sw-code-wrap]');
      if (code && !emailOnly) {
        if (codeEl) codeEl.textContent = code;
        if (codeWrap) codeWrap.hidden = false;
      } else {
        if (codeWrap) codeWrap.hidden = true;
      }
      // Email-only winners get an extra reassurance line so they know
      // the code is on its way (instead of just seeing the code box
      // disappear). Uses the slice label so the message is specific:
      // 'Please find your 50% off code in your emails.'
      // Since 2026-09-15 codes are minted for ALL customers (single-use via
      // usageLimit 1 + appliesOncePerCustomer), not bound to the entered
      // email: wallet checkouts (PayPal, Google Pay, Apple Pay) overwrite the
      // checkout email and Shopify stripped every bound code on the mismatch.
      // So the win screen no longer names a locked address.
      var emailNotice = root.querySelector('[data-ag-sw-email-notice]');
      if (emailNotice) {
        var noticeParts = [];
        if (emailOnly && codeWasReturned && p.klaviyo_coupon_id) {
          var sliceLabel = displayLabel(p.label) || 'discount';
          noticeParts.push('Please find your ' + sliceLabel + ' code in your emails.');
        }
        emailNotice.textContent = noticeParts.join(' ');
        emailNotice.hidden = noticeParts.length === 0;
      }

      if (expEl) {
        if (expiresAt) {
          var d = new Date(expiresAt);
          if (!isNaN(d.getTime())) {
            expEl.textContent = 'Expires ' + d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) + '.';
          } else {
            expEl.textContent = '';
          }
        } else if (USE_KLAVIYO_EXPIRY && codeWasReturned) {
          // Klaviyo returned no expiry for a successful mint, that
          // means the coupon is configured 'never expires'. Don't
          // fabricate one from the section fallback.
          expEl.textContent = '';
        } else if (CODE_EXPIRY_DAYS > 0) {
          var d2 = new Date(Date.now() + CODE_EXPIRY_DAYS * 24 * 60 * 60 * 1000);
          expEl.textContent = 'Expires ' + d2.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) + '.';
        } else {
          expEl.textContent = '';
        }
      }

      showView('won');
    }

    if (form) {
      var emailInput = form.querySelector('input[name="email"]');
      var consentInput = form.querySelector('input[name="marketing_consent"]');
      var consentLabel = form.querySelector('.ag-sw__check');
      var errorEl = form.querySelector('[data-ag-sw-form-error]');

      function setError(msg) {
        if (!errorEl) return;
        if (msg) {
          errorEl.textContent = msg;
          errorEl.hidden = false;
        } else {
          errorEl.textContent = '';
          errorEl.hidden = true;
        }
      }
      function clearInvalidStates() {
        if (emailInput) emailInput.classList.remove('is-invalid');
        if (consentLabel) consentLabel.classList.remove('is-invalid');
      }
      // Re-validate on input change so the red highlight clears as
      // soon as the user fixes the issue.
      [emailInput, consentInput].forEach(function (el) {
        if (!el) return;
        el.addEventListener('input', clearInvalidStates);
        el.addEventListener('change', clearInvalidStates);
      });

      // Client-side mirror of the server's disposable-email blocklist
      // (top ~40). Catches throwaway addresses BEFORE the wheel spins
      // so the user sees an instant error instead of waiting.
      var DISPOSABLE_EMAIL_DOMAINS = [
        'mailinator.com', 'mailinator2.com', 'tempmail.com', 'tempmail.us',
        'tempmail.eu', 'temp-mail.org', 'temp-mail.io',
        '10minutemail.com', '20minutemail.com', '30minutemail.com',
        'guerrillamail.com', 'guerrillamail.net', 'guerrillamail.org',
        'sharklasers.com', 'grr.la',
        'yopmail.com', 'yopmail.fr', 'yopmail.net',
        'throwaway.email', 'throwawaymail.com', 'fakeinbox.com', 'fakemail.net',
        'tempinbox.com', 'tempinbox.co.uk', 'mintemail.com', 'mohmal.com',
        'mytemp.email', 'maildrop.cc', 'minuteinbox.com', 'getairmail.com',
        'inboxbear.com', 'getnada.com', 'discardmail.com',
        'spam4.me', 'spamgourmet.com', 'mailcatch.com', 'tempmailaddress.com',
        'temporarymailaddress.com', 'dispostable.com', 'trashmail.com',
        'trashmail.de', 'trashmail.net', 'wegwerfmail.de', 'wegwerfemail.de'
      ];

      // Strict-enough regex: local-part, @, domain, ., TLD of 2+ alpha chars.
      // Rejects junk like 'a@b.c' or 'foo@bar' that the old check passed.
      var EMAIL_RE = /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/;

      function diagnoseEmail(value) {
        if (!value) return 'Please enter your email address.';
        if (value.indexOf('@') < 0) return 'Email is missing the @ symbol.';
        var parts = value.split('@');
        if (parts.length > 2) return 'Email can only have one @ symbol.';
        if (!parts[0]) return 'Add the part before the @ (e.g. you@example.com).';
        if (!parts[1] || parts[1].indexOf('.') < 0) return 'The domain after @ needs a dot (e.g. example.com).';
        if (!EMAIL_RE.test(value)) return 'That email doesn’t look right. Please check and try again.';
        var domain = parts[1].toLowerCase();
        if (DISPOSABLE_EMAIL_DOMAINS.indexOf(domain) >= 0) {
          return 'Throwaway email addresses aren’t accepted. Please use a real inbox.';
        }
        return ''; // valid
      }

      // ── Soft domain-typo hint ──────────────────────────────────────
      // Why this matters more than it looks: every UK wheel prize is
      // minted as a Shopify discount bound to the entered address via
      // customerSelection (Code.js:1125 / :1162), so a mistyped domain
      // costs the customer 100% of the prize on every winning slice.
      // The Klaviyo mail lands nowhere, AND a code read off the screen
      // belongs to a customer record they cannot check out as. There is
      // no partial loss here and nothing they can do to recover it.
      //
      // ADVISORY ONLY. This never rejects an address, and the server is
      // deliberately untouched: a server-side check could only refuse,
      // and refusing a real address is strictly worse than the typo.
      //
      // Deliberately a short explicit map keyed on the FULL domain
      // rather than edit-distance matching: predictable, reviewable in
      // a diff, and incapable of firing on a real domain that merely
      // resembles a big provider. Full-domain keys are what makes the
      // UK case safe - 'hotmail.co' can never touch 'hotmail.co.uk',
      // and the many legitimate British ISP domains (btinternet.com,
      // sky.com, virginmedia.com, talktalk.net, ntlworld.com,
      // blueyonder.co.uk, plus googlemail.com, which is a REAL Gmail
      // domain and not a typo) are simply absent from the map.
      var EMAIL_DOMAIN_TYPOS = {
        // ── gmail.com (5,456 real entrants, 41% of the sheet) ────────
        'gotmail.com': 'gmail.com', 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com',
        'gmaial.com': 'gmail.com', 'gmaill.com': 'gmail.com', 'gnail.com': 'gmail.com',
        'gamil.com': 'gmail.com', 'gmaiil.com': 'gmail.com', 'gmil.com': 'gmail.com',
        'gmsil.com': 'gmail.com', 'gmwil.com': 'gmail.com', 'gmaol.com': 'gmail.com',
        'gail.com': 'gmail.com', 'jgmail.com': 'gmail.com',
        'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com',
        'gmail.clm': 'gmail.com', 'gmail.cpm': 'gmail.com', 'gmail.om': 'gmail.com',
        'gmail.comm': 'gmail.com', 'gmail.comc': 'gmail.com', 'gmail.comd': 'gmail.com',
        'gmail.comg': 'gmail.com', 'gmail.comh': 'gmail.com', 'gmail.comi': 'gmail.com',
        // Klaviyo Spun Wheel, 8 to 27 Sep 2026: two each, missed by the map.
        'gmal.com': 'gmail.com', 'gmail.dom': 'gmail.com',
        // gmail.co.uk is not a Gmail mailbox domain: a British entrant
        // reaching for the country TLD. Six of them in the sheet, and
        // their mail went nowhere.
        'gmail.co.uk': 'gmail.com', 'gmail.com.uk.ac.uk': 'gmail.com',

        // ── googlemail.com ───────────────────────────────────────────
        // googlemail.com itself is a REAL Gmail domain with 339 real
        // entrants here. It is deliberately NOT a key, only a target.
        'googlemai.com': 'googlemail.com', 'googlmail.com': 'googlemail.com',
        'googkemail.com': 'googlemail.com', 'googlemaip.com': 'googlemail.com',
        'googlemial.com': 'googlemail.com', 'googlfmail.com': 'googlemail.com',
        'goolglemail.com': 'googlemail.com', 'googlemail..com': 'googlemail.com',
        // googlemail.co.uk is not a Google mailbox domain either.
        'googlemail.co.uk': 'googlemail.com',

        // ── hotmail.com (1,540 real) ─────────────────────────────────
        'hotmal.com': 'hotmail.com', 'homail.com': 'hotmail.com', 'hormail.com': 'hotmail.com',
        'hotmaul.com': 'hotmail.com', 'hoymail.com': 'hotmail.com', 'hotmial.com': 'hotmail.com',
        'hotmai.com': 'hotmail.com', 'hotnail.com': 'hotmail.com', 'hitmail.com': 'hotmail.com',
        'hotmain.com': 'hotmail.com', 'hotmaol.com': 'hotmail.com', 'hotmil.com': 'hotmail.com',
        'hotnsil.com': 'hotmail.com', 'htmail.com': 'hotmail.com', 'hoail.com': 'hotmail.com',
        'hotmails.com': 'hotmail.com',
        'hotmail.co': 'hotmail.com', 'hotmail.con': 'hotmail.com', 'hotmail.cm': 'hotmail.com',
        'hotmail.cpm': 'hotmail.com', 'hotmail.coom': 'hotmail.com',

        // ── hotmail.co.uk (1,294 real: the second-biggest UK provider,
        //    so it needs its own typo set, not just hotmail.com's) ────
        'hotmal.co.uk': 'hotmail.co.uk', 'hotmial.co.uk': 'hotmail.co.uk',
        'hotmai.co.uk': 'hotmail.co.uk', 'homail.co.uk': 'hotmail.co.uk',
        'hotnail.co.uk': 'hotmail.co.uk', 'hitmail.co.uk': 'hotmail.co.uk',
        'hotlmail.co.uk': 'hotmail.co.uk', 'hotmil.co.uk': 'hotmail.co.uk',
        'hotmail.co.u': 'hotmail.co.uk', 'hotmail.co.uj': 'hotmail.co.uk',
        'hotmail.co.ul': 'hotmail.co.uk', 'hotmail.couk': 'hotmail.co.uk',
        'hotmail.co.ukhide': 'hotmail.co.uk',

        // ── outlook.com / outlook.co.uk ──────────────────────────────
        'outlok.com': 'outlook.com', 'outloo.com': 'outlook.com', 'oultook.com': 'outlook.com',
        'outook.com': 'outlook.com', 'putlook.com': 'outlook.com',
        'outlook.co': 'outlook.com', 'outlook.con': 'outlook.com', 'outlook.comy': 'outlook.com',
        'outlok.co.uk': 'outlook.co.uk', 'outloo.co.uk': 'outlook.co.uk',

        // ── yahoo.co.uk (437 real) / yahoo.com (301 real) ────────────
        // Other yahoo regionals seen in the sheet (yahoo.co.in,
        // yahoo.ca, yahoo.com.hk) are REAL and stay out of the map.
        'yaho.co.uk': 'yahoo.co.uk', 'yahooo.co.uk': 'yahoo.co.uk', 'yaboo.co.uk': 'yahoo.co.uk',
        'yahoo.co.u': 'yahoo.co.uk', 'yahoo.co.uo': 'yahoo.co.uk', 'yahoo.vo.uk': 'yahoo.co.uk',
        'yahoo.co.ukkk': 'yahoo.co.uk',
        'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahaoo.com': 'yahoo.com',
        'yahoo.con': 'yahoo.com', 'yahoo.cm': 'yahoo.com', 'yahoo.comi': 'yahoo.com',
        'yahoo.comm': 'yahoo.com', 'yahoo.vom': 'yahoo.com', 'yahoo.xcom': 'yahoo.com',
        'yahoo.coom': 'yahoo.com', 'yahoo.cooo': 'yahoo.com', 'yahoo.cooom': 'yahoo.com',

        // ── icloud.com (743 real) ────────────────────────────────────
        'iclod.com': 'icloud.com', 'iclou.com': 'icloud.com', 'icoud.com': 'icloud.com',
        'iclould.com': 'icloud.com', 'ocloud.com': 'icloud.com',
        'icloud.co': 'icloud.com', 'icloud.con': 'icloud.com', 'icloud.cln': 'icloud.com',
        'icloud.col': 'icloud.com', 'icloud.coml': 'icloud.com', 'icloud.comy': 'icloud.com',
        // Apple runs no icloud.co.uk mailbox; the country TLD slip again.
        'icloud.co.uk': 'icloud.com',

        // ── live.co.uk (265 real) / live.com (92 real) ───────────────
        // live.co.za is REAL and stays out.
        'liv.co.uk': 'live.co.uk', 'live.co.u': 'live.co.uk',
        'live.cxo.uk': 'live.co.uk', 'oive.co.uk': 'live.co.uk',
        'liv.com': 'live.com', 'live.con': 'live.com',

        // ── btinternet.com (159 real) ────────────────────────────────
        // bt.com is a REAL BT domain and stays out.
        'btinternet.co': 'btinternet.com', 'btinternet.con': 'btinternet.com',
        'btintenet.com': 'btinternet.com', 'btinernet.com': 'btinternet.com',
        'btingernet.com': 'btinternet.com', 'btinyernet.com': 'btinternet.com',
        'btinternet.comd': 'btinternet.com', 'btinternet.comh': 'btinternet.com',

        // ── me.com (157 real) / blueyonder.co.uk ─────────────────────
        'me.comk': 'me.com',
        'bluetonder.co.uk': 'blueyonder.co.uk', 'blueyonder.co.ukll': 'blueyonder.co.uk'
      };

      var typoBox  = form.querySelector('[data-ag-sw-typo]');
      var typoText = form.querySelector('[data-ag-sw-typo-text]');
      var typoFix  = form.querySelector('[data-ag-sw-typo-fix]');
      var typoKeep = form.querySelector('[data-ag-sw-typo-keep]');
      var typoSuggestion = '';   // the corrected address currently offered
      var typoDismissed  = {};   // domains the user has explicitly kept
      var typoHeldValue  = '';   // the exact address we already queried once

      // Returns the corrected address, or '' if the domain isn't a known
      // typo or the user has already said this domain is correct.
      function suggestEmail(value) {
        var v = String(value || '').trim();
        var at = v.lastIndexOf('@');
        if (at < 1 || at === v.length - 1) return '';
        var domain = v.slice(at + 1).toLowerCase();
        if (typoDismissed[domain]) return '';
        var fixed = EMAIL_DOMAIN_TYPOS[domain];
        if (!fixed) return '';
        return v.slice(0, at) + '@' + fixed;
      }

      function hideTypoHint() {
        typoSuggestion = '';
        if (typoBox) typoBox.hidden = true;
      }

      function showTypoHint(value) {
        if (!typoBox) return;
        var s = suggestEmail(value);
        if (!s) { hideTypoHint(); return; }
        typoSuggestion = s;
        if (typoText) typoText.textContent = 'Did you mean ' + s + '?';
        typoBox.hidden = false;
      }

      if (emailInput) {
        // Show on blur, hide again the moment they resume typing: a hint
        // that reappears on every keystroke while someone is mid-address
        // is noise, since every half-typed domain looks wrong.
        emailInput.addEventListener('blur', function () { showTypoHint(emailInput.value); });
        emailInput.addEventListener('input', hideTypoHint);
      }

      if (typoFix) {
        typoFix.addEventListener('click', function () {
          if (!typoSuggestion || !emailInput) return;
          emailInput.value = typoSuggestion;
          typoHeldValue = '';
          hideTypoHint();
          clearInvalidStates();
          setError('');
          emailInput.focus();
        });
      }

      if (typoKeep) {
        typoKeep.addEventListener('click', function () {
          // Remember the refusal so this domain never asks twice.
          var v = emailInput ? String(emailInput.value).trim() : '';
          var at = v.lastIndexOf('@');
          if (at > 0) typoDismissed[v.slice(at + 1).toLowerCase()] = true;
          hideTypoHint();
          if (emailInput) emailInput.focus();
        });
      }

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        clearInvalidStates();
        setError('');

        var fd = new FormData(form);

        // Honeypot, bots fill this hidden field; humans don't see it.
        // Pretend success so bots don't realise we filtered them out.
        if ((fd.get('agsw_website') || '').toString().trim() !== '') {
          showView('won');
          return;
        }

        var email = (fd.get('email') || '').toString().trim();
        var consent = !!fd.get('marketing_consent');
        var consentRequired = !!consentInput; // present in DOM only when section setting is on

        var emailError = diagnoseEmail(email);
        var consentMet = !consentRequired || consent;

        if (emailError || !consentMet) {
          if (emailError && emailInput) {
            emailInput.classList.add('is-invalid');
            emailInput.focus();
          }
          if (!consentMet && consentLabel) consentLabel.classList.add('is-invalid');
          var msgs = [];
          if (emailError) msgs.push(emailError);
          if (!consentMet) msgs.push('Please tick the box to enter.');
          setError(msgs.join(' '));
          return;
        }

        // Typo hint, one time per address. On mobile the CTA tap blurs the
        // input and submits in the same gesture, so a blur-only hint would
        // be replaced by the spinning wheel before anyone could read it.
        // This holds that first press and shows the suggestion instead.
        // It is NOT a rejection: pressing the CTA again with the same
        // address goes straight through, whether or not they used either
        // button. No address is ever refused on a heuristic.
        if (suggestEmail(email) && typoHeldValue !== email) {
          typoHeldValue = email;
          showTypoHint(email);
          return;
        }
        hideTypoHint();

        submitBtn.disabled = true;
        ctaLabel.textContent = 'Spinning…';
        showView('spinning');
        didSpin = true; // abandonment tracker, they're committed now
        // Start the wheel spinning immediately so there's no dead air
        // while we're waiting for the backend to respond.
        startSpinLoop();

        // Spin animation + backend call run in parallel; we land the
        // wheel based on the backend's chosen index.
        var _spinPayload = {
          email: email,
          marketing_consent: consent,
          prizes: prizes,
          code_expiry_days: CODE_EXPIRY_DAYS,
          use_klaviyo_expiry: USE_KLAVIYO_EXPIRY,
          device_id: getOrCreateDeviceId(),
          // This build renders a returning prize that is no longer on the
          // wheel from the response, so the backend may send prize_index -1.
          supports_stored_win: true
        };
        if (TEST_MODE) {
          _spinPayload.test_secret = TEST_SECRET;
          _spinPayload.force_prize_index = FORCE_PRIZE_INDEX;
          try { localStorage.setItem(TEST_EMAIL_KEY, email); } catch (e) {}
        }
        var backendPromise = callBackend(_spinPayload);

        // Minimum spin duration, guarantees the wheel always looks
        // like it's spun for a moment before decelerating, even when
        // the backend responds in <300ms (warm + parallel Klaviyo).
        // Pullback eats 450ms; the remainder is loop time before
        // deceleration kicks in. 500ms is the bare minimum, feels
        // snappy without the wheel just teleporting to the result.
        var MIN_SPIN_MS = 500;
        var minDelayPromise = new Promise(function (resolve) {
          setTimeout(resolve, MIN_SPIN_MS);
        });

        Promise.all([backendPromise, minDelayPromise]).then(function (vals) {
          var res = vals[0];
          var prizeIndex, code, expiresAt, alreadySpun = false;
          if (res && res.ok && typeof res.prize_index === 'number') {
            prizeIndex = res.prize_index;
            code = res.code || '';
            expiresAt = res.expires_at;
            alreadySpun = !!res.already_spun;
          } else if (res && res.error) {
            // Real error from backend (invalid email, etc.), stop
            // the wheel before swapping to the error view so the
            // loop animation doesn't keep running underneath.
            cancelSpin();
            stopNotchTracking();
            rotGroup.classList.remove('is-looping');
            rotGroup.style.animationDelay = '';
            rotGroup.style.transition = 'none';
            showView('error');
            var errEl = root.querySelector('[data-ag-sw-error-msg]');
            if (errEl) errEl.textContent = res.error;
            return;
          } else if (!ENDPOINT) {
            // Demo mode. ONLY when no endpoint is configured (editor preview /
            // unconfigured wheel). Pick locally, placeholder code.
            prizeIndex = pickPrizeLocally();
            code = 'DEMO-' + Math.random().toString(36).slice(2, 7).toUpperCase();
          } else {
            // Endpoint IS configured but the response matched neither the
            // success nor the error contract (timeout, cold-start HTML page,
            // malformed JSON). Must NOT show a fake DEMO-XXXX code as a real
            // win (it fails at checkout), route to the error view instead.
            cancelSpin();
            stopNotchTracking();
            rotGroup.classList.remove('is-looping');
            rotGroup.style.animationDelay = '';
            rotGroup.style.transition = 'none';
            showView('error');
            var errEl2 = root.querySelector('[data-ag-sw-error-msg]');
            if (errEl2) errEl2.textContent = 'Something went wrong. Please try again in a moment.';
            return;
          }

          // The prize's identity. The backend sends it (from the Spins row for
          // a returning customer); an older backend, or demo mode, does not,
          // and then the wedge itself is the only identity there is.
          var slot = prizes[prizeIndex];
          var hasIdentity = !!res && (typeof res.prize_label === 'string' || typeof res.klaviyo_coupon_id === 'string');
          var resCoupon = hasIdentity ? String(res.klaviyo_coupon_id || '').trim() : ((slot || {}).klaviyo_coupon_id || '');
          var resLabel = hasIdentity ? String(res.prize_label || '').trim() : ((slot || {}).label || '');
          // The backend's explicit no_prize wins; infer it only when it is absent.
          var resNoPrize = hasIdentity && (typeof res.no_prize === 'boolean' ? res.no_prize : (!resCoupon && !code));
          // Land on a wedge only when it carries the prize they actually won.
          var slotAgrees = !!slot && (!hasIdentity || sliceMatchesResponse(slot, res));
          var offWheel = hasIdentity && (prizeIndex < 0 || res.prize_on_wheel === false || !slotAgrees);

          // An older backend (no identity) replays a returning customer's
          // STORED wedge index, which may now be somebody else's prize, and a
          // winning wedge with no code is exactly that: a No Prize row landed
          // on 50% OFF. So is an index off the end of the wheel. Do not show a
          // win, do not tell them to contact us for a code, and do not send
          // them round an error-and-retry loop. Say they have already spun,
          // and nothing more.
          if (!hasIdentity && ENDPOINT && (!slot || (slot.klaviyo_coupon_id && !code))) {
            saveState({
              lastSpunAt: Date.now(),
              lastDismissedAt: Date.now(),
              email: email,
              prize_index: -1,
              coupon: '',
              label: '',
              code: '',
              expires_at: '',
              already_spun: true,
              no_prize: false
            });
            haltSpin(-1);
            setNoPrizeCopy('neutral');
            showView('noprize');
            applyStickyText();
            return;
          }

          // Save state so we don't re-trigger. Stamp both timestamps
          // so the cooldown stays correct regardless of which one we
          // check against. We also remember the prize so the sticky
          // tab can re-show the won view directly without a backend
          // round-trip. coupon and label come from the RESPONSE, never
          // from prizes[prizeIndex]: prize_index is positional, and a
          // returning customer's prize may sit elsewhere or nowhere.
          var savedIndex = prizeIndex;
          if (resNoPrize && alreadySpun) {
            savedIndex = (slot && !slot.klaviyo_coupon_id) ? prizeIndex : firstNoPrizeIndex();
          } else if (offWheel) {
            savedIndex = -1; // no wedge carries this prize
          }
          saveState({
            lastSpunAt: Date.now(),
            lastDismissedAt: Date.now(),
            email: email,
            prize_index: savedIndex,
            coupon: resCoupon,
            label: resLabel,
            code: code,
            expires_at: expiresAt,
            already_spun: alreadySpun,
            no_prize: resNoPrize,
            // Trusted only when the backend named the prize (see stateTrusted).
            state_v: hasIdentity ? STATE_VERSION : 0
          });

          // Returning NO PRIZE spinner: no spin, no sad trombone. Say they have
          // already spun and won nothing, with the wheel resting on NO PRIZE.
          if (resNoPrize && alreadySpun) {
            haltSpin(savedIndex);
            setNoPrizeCopy(true);
            showView('noprize');
            applyStickyText();
            return;
          }
          // Their prize is not on this wheel, or the wedge at prize_index is a
          // different prize: do not spin onto anything. Show what they won.
          if (offWheel && !resNoPrize) {
            showResponseWin({ prize_label: resLabel, klaviyo_coupon_id: resCoupon, code: code, expires_at: expiresAt }, alreadySpun);
            applyStickyText();
            return;
          }
          if (prizeIndex < 0 || !slot) {
            // Nothing to land on and nothing identifiable to show. Never guess.
            haltSpin(-1);
            showView('error');
            var errEl3 = root.querySelector('[data-ag-sw-error-msg]');
            if (errEl3) errEl3.textContent = 'Something went wrong. Please try again in a moment.';
            return;
          }
          setNoPrizeCopy(false);

          // End the loop and decelerate to the chosen slice. The
          // function returns the deceleration duration in ms so we
          // reveal the result exactly as the wheel comes to a stop.
          var decelMs = endLoopAndLand(prizeIndex);
          setTimeout(function () {
            // hasIdentity here means the wedge agrees with the backend's
            // identity (anything else took the offWheel path above).
            showResult(prizeIndex, code, expiresAt, alreadySpun, null, hasIdentity);
            var p = prizes[prizeIndex] || {};
            if (p.klaviyo_coupon_id) {
              fireConfetti(p.confetti_color || '');
              playDing();
            } else {
              // No-prize spin, sad-trombone wah-wah for the loss
              playSadTrombone();
            }
            // Update sticky text now that they've spun, next time
            // they see the side tab it'll read "View your code".
            applyStickyText();
          }, decelMs + 150);
        }).catch(function () {
          // Network stall / abort / offline. Stop every animation loop so the
          // wheel doesn't keep spinning under the error view, then surface it.
          cancelSpin();
          stopNotchTracking();
          rotGroup.classList.remove('is-looping');
          rotGroup.style.transition = 'none';
          showView('error');
        });
      });
    }

    // ── Copy code ─────────────────────────────────────────────────────
    var copyBtn = root.querySelector('[data-ag-sw-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var codeEl = root.querySelector('[data-ag-sw-result-code]');
        if (!codeEl) return;
        var txt = codeEl.textContent.trim();
        var done = function () {
          copyBtn.classList.add('is-copied');
          copyBtn.textContent = 'Copied';
          setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            copyBtn.textContent = 'Copy';
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(txt).then(done).catch(done);
        } else {
          done();
        }
      });
    }
  })();
